/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(4);
	var react_router_1 = __webpack_require__(5);
	var MasonDotNet_1 = __webpack_require__(6);
	var $ = __webpack_require__(17);
	var Parametric_1 = __webpack_require__(25);
	var Markov_1 = __webpack_require__(34);
	var Matrix_1 = __webpack_require__(71);
	var Nav_1 = __webpack_require__(74);
	__webpack_require__(75);
	__webpack_require__(77);
	__webpack_require__(78);
	__webpack_require__(79);
	__webpack_require__(81);
	$(document).ready(function () {
	    var root = document.getElementById("root");
	    var router = React.createElement(react_router_1.Router, { history: react_router_1.browserHistory },
	        React.createElement(react_router_1.Route, { path: "/main", component: MasonDotNet_1.MasonDotNet }),
	        React.createElement(react_router_1.Route, { path: "/", component: Nav_1.Nav },
	            React.createElement(react_router_1.IndexRedirect, { to: "/main" }),
	            React.createElement(react_router_1.Route, { path: "/markov/:graphSerialization", component: Markov_1.Markov }),
	            React.createElement(react_router_1.Route, { path: "/markov", component: Markov_1.Markov }),
	            React.createElement(react_router_1.Route, { path: "/parametric", component: Parametric_1.Parametric }),
	            React.createElement(react_router_1.Route, { path: "/matrixtest", component: Matrix_1.NumericMatrix })));
	    if (root) {
	        ReactDOM.render(router, root);
	    }
	});


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(1);

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = vendor_lib;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(28);

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(862);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(2);
	var react_router_1 = __webpack_require__(5);
	var Sauce = __webpack_require__(7);
	var ParametricCurve_1 = __webpack_require__(13);
	var Plotter_1 = __webpack_require__(14);
	var Util = __webpack_require__(19);
	__webpack_require__(21);
	var MasonDotNet = (function (_super) {
	    __extends(MasonDotNet, _super);
	    function MasonDotNet(props) {
	        return _super.call(this, props) || this;
	    }
	    MasonDotNet.prototype.render = function () {
	        return React.DOM.div({ className: "container" }, React.DOM.h1({}, "Mason Net"), React.DOM.div({ className: "math-showcase-description" }, "", React.createElement("ul", { className: "math-showcase" },
	            React.createElement(react_router_1.Link, { to: "/parametric" },
	                React.createElement("li", { className: "lissajous" },
	                    React.createElement(Plotter_1.Plotter, { curves: [{ key: Util.makeDomId("Lissajous10,9"), value: new ParametricCurve_1.Lissajous(10, 9) }], tmin: Math.PI * -1, tmax: Math.PI, xmin: -1, xmax: 1, ymin: -1, ymax: 1, numSamples: 2000 }),
	                    "Virtual oscilloscope. Demonstrating the integration of React, d3, and RxJS in a performance-intensive application.")))), React.createElement("div", null));
	    };
	    return MasonDotNet;
	}(Sauce.Component));
	exports.MasonDotNet = MasonDotNet;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(8));
	__export(__webpack_require__(10));


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(2);
	var Rx = __webpack_require__(9);
	var Component = (function (_super) {
	    __extends(Component, _super);
	    function Component(props) {
	        var _this = _super.call(this, props) || this;
	        _this.subscription = new Rx.Subscription();
	        return _this;
	    }
	    Component.prototype.add = function (sub) {
	        return this.subscription.add(sub);
	    };
	    Component.prototype.subscribe = function (observable, observer) {
	        var sub = observable.subscribe(observer);
	        this.subscription.add(sub);
	        return sub;
	    };
	    Component.prototype.remove = function (sub) {
	        this.subscription.remove(sub);
	        sub.unsubscribe();
	    };
	    Component.prototype.componentWillUnmount = function () {
	        this.subscription.unsubscribe();
	    };
	    return Component;
	}(React.Component));
	exports.Component = Component;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(1035);

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(2);
	var Sauce = __webpack_require__(7);
	var _ = __webpack_require__(11);
	var Validation_1 = __webpack_require__(12);
	var Form = (function (_super) {
	    __extends(Form, _super);
	    function Form() {
	        var _this = _super.apply(this, arguments) || this;
	        _this.dirty = false;
	        _this.focus = function () {
	            _this.setState({ focused: true });
	        };
	        _this.blur = function () {
	            _this.flush(_this.state.value);
	            _this.setState({ focused: false });
	        };
	        _this.flush = function (next_val) {
	            if (next_val.format_exception)
	                console.warn(next_val.format_exception);
	            if (next_val.process_exception)
	                console.warn(next_val.process_exception);
	            _this.setState({ dirty: false });
	            _this.props.flush(next_val);
	        };
	        _this.displayValue = function () {
	            if (_this.state.focused || _this.state.dirty) {
	                return _this.state.value.raw;
	            }
	            return _this.state.value.formatted;
	        };
	        _this.makeClasses = function () {
	            return (_this.props.className ? _this.props.className : "") +
	                (_this.state.dirty ? " dirty" : "") +
	                (!_this.state.value.valid ? " invalid" : "") +
	                (_this.state.focused ? " focused" : "");
	        };
	        return _this;
	    }
	    Form.prototype.update_state_handler = function (state_key, processor) {
	        var _this = this;
	        return function (ev) {
	            var next_val = processor(ev);
	            _this.set_value(state_key, next_val);
	        };
	    };
	    Form.prototype.wrap = function (handler, before, after) {
	        return function (ev) {
	            var _ev = before ? before(ev) : ev;
	            handler(_ev);
	            after ? after(_ev) : null;
	        };
	    };
	    Form.prototype.enterdown = function (fn) {
	        return function (ev) {
	            if (ev.key == "Enter") {
	                fn(ev);
	            }
	        };
	    };
	    Form.prototype.parsePropValue = function (val) {
	        if (val instanceof Validation_1.ParseResult) {
	            return val;
	        }
	        else {
	            return this.props.processor(val);
	        }
	    };
	    Form.prototype.initState = function (props) {
	        var origval = props.value != null ? this.parsePropValue(props.value) : props.processor("");
	        return {
	            value: origval,
	            dirty: false,
	            focused: Boolean(this.props.autoFocus)
	        };
	    };
	    Form.prototype.componentWillReceiveProps = function (props) {
	        if (!this.state.dirty && props.value) {
	            this.setState({ value: this.parsePropValue(props.value) });
	        }
	    };
	    Form.prototype.shouldComponentRender = function (nextP, nextS) {
	        var cond = this.state.value.raw !== nextS.value.raw;
	        if (!cond) {
	            console.log("Don't re-render form", this.state.value.raw, nextS.value.raw);
	        }
	        return this.state.value.raw !== nextS.value.raw;
	    };
	    Form.prototype.set_value = function (key, val) {
	        var state = {};
	        var prev = this.state;
	        if (val.raw !== prev[key].raw) {
	            state[key] = val;
	            this.setState(state);
	            this.dirty = true;
	        }
	    };
	    return Form;
	}(Sauce.Component));
	exports.Form = Form;
	var NumberInput = (function (_super) {
	    __extends(NumberInput, _super);
	    function NumberInput(props) {
	        var _this = _super.call(this, props) || this;
	        _this.on_change = _this.wrap(_this.update_state_handler("value", props.processor), function (ev) {
	            _this.setState({ dirty: true });
	            return ev;
	        });
	        _this.keydown = (function (ev) {
	            if (ev.key == "Enter") {
	                _this.flush(_this.state.value);
	                _this.setState({ dirty: false });
	            }
	            else if (ev.key == "ArrowUp") {
	                _this.on_change((_this.state.value.value + _this.state.increment).toString());
	            }
	            else if (ev.key == "ArrowDown") {
	                _this.on_change((_this.state.value.value - _this.state.increment).toString());
	            }
	        });
	        var inc = _.isFinite(props.default_increment) ? props.default_increment : 1;
	        _this.state = __assign({}, _this.initState(props), { increment: inc });
	        return _this;
	    }
	    NumberInput.prototype.render = function () {
	        return React.createElement("input", { type: "text", style: this.props.style, autoFocus: this.props.autoFocus, className: this.makeClasses(), value: this.displayValue(), onChange: this.on_change, onKeyDown: this.keydown, onFocus: this.focus, onBlur: this.blur });
	    };
	    return NumberInput;
	}(Form));
	exports.NumberInput = NumberInput;
	var Checkbox = (function (_super) {
	    __extends(Checkbox, _super);
	    function Checkbox(props) {
	        var _this = _super.call(this, props) || this;
	        _this.state = {
	            value: props.initialValue instanceof Validation_1.ParseResult ? props.initialValue : props.processor(props.initialValue),
	            dirty: false,
	            focused: _this.props.autoFocus
	        };
	        _this.on_change = _this.wrap(_this.update_state_handler("value", props.processor), undefined, function (ev) {
	            var next = props.processor(ev);
	            _this.flush(next);
	            return ev;
	        });
	        _this.state = _this.initState(props);
	        return _this;
	    }
	    Checkbox.prototype.render = function () {
	        return React.createElement("input", { type: "checkbox", style: this.props.style, className: this.makeClasses(), checked: this.state.value.value !== null ? this.state.value.value : undefined, onBlur: this.blur, onFocus: this.focus, onChange: this.on_change });
	    };
	    return Checkbox;
	}(Form));
	exports.Checkbox = Checkbox;
	var TextAreaInput = (function (_super) {
	    __extends(TextAreaInput, _super);
	    function TextAreaInput(props) {
	        var _this = _super.call(this, props) || this;
	        _this.on_change = _this.wrap(_this.update_state_handler("value", props.processor), function (ev) {
	            _this.setState({ dirty: true });
	            return ev;
	        });
	        _this.enter = _this.enterdown(function () {
	            _this.flush(_this.state.value);
	            _this.setState({ dirty: false });
	        });
	        _this.state = _this.initState(props);
	        return _this;
	    }
	    TextAreaInput.prototype.render = function () {
	        return React.createElement("textarea", { type: "text", style: this.props.style, autoFocus: this.props.autoFocus, className: this.makeClasses(), value: this.displayValue(), onChange: this.on_change, onKeyDown: this.enter, onFocus: this.focus, onBlur: this.blur });
	    };
	    return TextAreaInput;
	}(Form));
	exports.TextAreaInput = TextAreaInput;
	var StringTextAreaInput = (function (_super) {
	    __extends(StringTextAreaInput, _super);
	    function StringTextAreaInput() {
	        return _super.apply(this, arguments) || this;
	    }
	    return StringTextAreaInput;
	}(TextAreaInput));
	exports.StringTextAreaInput = StringTextAreaInput;
	var TextInput = (function (_super) {
	    __extends(TextInput, _super);
	    function TextInput(props) {
	        var _this = _super.call(this, props) || this;
	        _this.on_change = _this.wrap(_this.update_state_handler("value", props.processor), function (ev) {
	            _this.setState({ dirty: true });
	            return ev;
	        });
	        _this.enter = _this.enterdown(function () {
	            _this.flush(_this.state.value);
	            _this.setState({ dirty: false });
	        });
	        _this.state = _this.initState(props);
	        return _this;
	    }
	    TextInput.prototype.render = function () {
	        return React.createElement("input", { type: "text", style: this.props.style, autoFocus: this.props.autoFocus, className: this.makeClasses(), value: this.displayValue(), onFocus: this.focus, onChange: this.on_change, onKeyDown: this.enter, onBlur: this.blur });
	    };
	    return TextInput;
	}(Form));
	exports.TextInput = TextInput;
	var StringTextInput = (function (_super) {
	    __extends(StringTextInput, _super);
	    function StringTextInput() {
	        return _super.apply(this, arguments) || this;
	    }
	    return StringTextInput;
	}(TextInput));
	exports.StringTextInput = StringTextInput;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(1034);

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	var ParseResult = (function () {
	    function ParseResult(raw, value, formatted, errorMsg, valid) {
	        if (errorMsg === void 0) { errorMsg = undefined; }
	        if (valid === void 0) { valid = true; }
	        this.raw = raw;
	        this.value = value;
	        this.formatted = formatted;
	        this.errorMsg = errorMsg;
	        this.valid = valid;
	    }
	    return ParseResult;
	}());
	exports.ParseResult = ParseResult;
	function isEv(v) {
	    return v && v.currentTarget !== undefined;
	}
	function isStr(v) {
	    return typeof v === 'string';
	}
	function extract_raw(v) {
	    if (isEv(v)) {
	        if (v.currentTarget.type === 'checkbox') {
	            return v.currentTarget.checked ? "1" : "";
	        }
	        else {
	            return v.currentTarget.value;
	        }
	    }
	    else if (isStr(v)) {
	        return v;
	    }
	    else if (typeof (v) === 'number') {
	        return v.toString();
	    }
	    else if (typeof (v) === 'boolean') {
	        return v ? "1" : "";
	    }
	    else
	        return "";
	}
	exports.extract_raw = extract_raw;
	var ValueProcessorFactory = (function () {
	    function ValueProcessorFactory(process, postvalidate, format, prevalidate, preformat) {
	        this.process = process;
	        this.postvalidate = postvalidate;
	        this.format = format;
	        this.prevalidate = prevalidate;
	        this.preformat = preformat;
	    }
	    ValueProcessorFactory.prototype.make = function () {
	        var prevalidate = this.prevalidate ? this.prevalidate : function () { return ""; };
	        var process = this.process ? this.process : function (s) { return s; };
	        var postvalidate = this.postvalidate ? this.postvalidate : function () { return ""; };
	        var format = this.format ? this.format : function (processed, preformatted) { return preformatted; };
	        var preformat = this.preformat ? this.preformat : function (raw) { return raw; };
	        return function (source) {
	            var raw = extract_raw(source);
	            var processed = null;
	            var errMsg;
	            var formatted = raw;
	            var valid = true;
	            var process_exception;
	            var format_exception;
	            try {
	                formatted = preformat(raw);
	                try {
	                    errMsg = prevalidate(formatted);
	                    valid = !errMsg;
	                    if (valid) {
	                        try {
	                            processed = process(formatted);
	                            errMsg = postvalidate(processed, formatted);
	                            valid = !errMsg;
	                            try {
	                                formatted = format(processed, formatted);
	                            }
	                            catch (e) {
	                                valid = false;
	                                formatted = raw;
	                                errMsg = e.message;
	                                format_exception = e;
	                            }
	                        }
	                        catch (e) {
	                            valid = false;
	                            processed = null;
	                            errMsg = e.message;
	                            process_exception = e;
	                        }
	                    }
	                    else {
	                        processed = null;
	                    }
	                }
	                catch (e) {
	                    processed = null;
	                    valid = false;
	                    process_exception = e;
	                }
	            }
	            catch (e) {
	                valid = false;
	                processed = null;
	                errMsg = e.message;
	                format_exception = e;
	            }
	            var rv = new ParseResult(raw, processed, formatted, errMsg, valid);
	            rv.process_exception = process_exception;
	            rv.format_exception = format_exception;
	            return rv;
	        };
	    };
	    return ValueProcessorFactory;
	}());
	exports.ValueProcessorFactory = ValueProcessorFactory;


/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	var ParametricCurve2 = (function () {
	    function ParametricCurve2() {
	    }
	    return ParametricCurve2;
	}());
	exports.ParametricCurve2 = ParametricCurve2;
	var SimpleParametricCurve2 = (function () {
	    function SimpleParametricCurve2(x, y) {
	        this.x = x;
	        this.y = y;
	    }
	    return SimpleParametricCurve2;
	}());
	exports.SimpleParametricCurve2 = SimpleParametricCurve2;
	var Func = (function () {
	    function Func(f) {
	        this.f = f;
	    }
	    Func.prototype.x = function (t) { return t; };
	    Func.prototype.y = function (t) { return this.f(t); };
	    return Func;
	}());
	exports.Func = Func;
	var Lissajous = (function () {
	    function Lissajous(a, b, A, B, phaseOffset) {
	        if (a === void 0) { a = 1; }
	        if (b === void 0) { b = 1; }
	        if (A === void 0) { A = 1; }
	        if (B === void 0) { B = 1; }
	        if (phaseOffset === void 0) { phaseOffset = 0; }
	        this.a = a;
	        this.b = b;
	        this.A = A;
	        this.B = B;
	        this.phaseOffset = phaseOffset;
	    }
	    Lissajous.prototype.x = function (t) {
	        return this.A * Math.sin(this.a * t + this.phaseOffset);
	    };
	    Lissajous.prototype.y = function (t) {
	        return this.B * Math.sin(this.b * t);
	    };
	    return Lissajous;
	}());
	exports.Lissajous = Lissajous;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Sauce = __webpack_require__(7);
	var React = __webpack_require__(2);
	var Geometry_1 = __webpack_require__(15);
	var _ = __webpack_require__(11);
	var ReactDOM = __webpack_require__(4);
	var d3 = __webpack_require__(16);
	var $ = __webpack_require__(17);
	var UIConstants_1 = __webpack_require__(18);
	var Plotter = (function (_super) {
	    __extends(Plotter, _super);
	    function Plotter(props) {
	        var _this = _super.call(this, props) || this;
	        _this.numSamples = 100;
	        _this.margin = UIConstants_1.ChartMargins;
	        if (props.numSamples > 0) {
	            _this.numSamples = props.numSamples;
	        }
	        if (props.margin) {
	            _this.margin = props.margin;
	        }
	        _this.state = { curveUpdates: _this.getIntersections([], props.curves ? props.curves : []) };
	        return _this;
	    }
	    Plotter.prototype.getIntersections = function (prev, next) {
	        var removed = _.differenceBy(prev, next, function (v) { return v.key; });
	        var added = _.differenceBy(next, prev, function (v) { return v.key; });
	        var retained = _.differenceBy(next, added.concat(removed), function (v) { return v.key; });
	        return {
	            addCurves: added,
	            removeCurves: removed,
	            updateCurves: retained
	        };
	    };
	    Plotter.prototype.sample = function (curve) {
	        var interval = (this.props.tmax - this.props.tmin) / (this.numSamples - 1);
	        var s = [];
	        for (var i = 0; i < this.numSamples; i++) {
	            var t = this.props.tmin + i * interval;
	            s.push(new Geometry_1.Position2(curve.x(t), curve.y(t)));
	        }
	        return s;
	    };
	    Plotter.prototype.createChart = function (el) {
	        var svg = d3.select(el)
	            .attr('class', 'geometry-plotter')
	            .attr('width', '100%')
	            .attr('height', '100%');
	        var $svg = $(el).first();
	        this.ow = $svg.width();
	        this.oh = $svg.height();
	        this.width = this.ow - this.margin.left - this.margin.right;
	        this.height = this.oh - this.margin.top - this.margin.bottom;
	        svg.append('g')
	            .attr('class', 'x-axis-bottom')
	            .attr('transform', 'translate(' + (this.margin.left) + ', ' + (this.oh - (this.margin.bottom)) + ')');
	        svg.append('g')
	            .attr('class', 'y-axis-left')
	            .attr('transform', 'translate(' + (this.margin.left) + ', ' + (this.margin.top) + ')');
	        svg.append('g')
	            .attr('class', 'chart-canvas')
	            .attr('transform', "translate(" + this.margin.left + "," + this.margin.top + ")")
	            .attr("width", this.width)
	            .attr("height", this.height);
	        svg.append('svg')
	            .attr('id', 'view-no-x-margins')
	            .attr('y', this.margin.top)
	            .attr('height', this.height)
	            .append('g')
	            .attr('class', 'no-x-margins');
	        svg.append('svg')
	            .attr('id', 'view-no-y-margins')
	            .attr('x', this.margin.left)
	            .attr('y', 0)
	            .attr('width', this.width)
	            .attr('height', "100%")
	            .append('g')
	            .attr('class', 'no-y-margins');
	        this.updateChart(el);
	    };
	    Plotter.prototype.removeLines = function (el, ids) {
	        var svg = d3.select(el);
	        var g = svg.select("g.chart-canvas");
	        var no_x_margins = svg.select("g.no-x-margins");
	        var no_y_margins = svg.select("g.no-y-margins");
	        for (var _i = 0, ids_1 = ids; _i < ids_1.length; _i++) {
	            var id = ids_1[_i];
	            var path = g.select("#" + id);
	            var vtrace = no_y_margins.select("#vtrace-" + id);
	            var htrace = no_x_margins.select("#htrace-" + id);
	            path.remove();
	            vtrace.remove();
	            htrace.remove();
	        }
	    };
	    Plotter.prototype.drawOneLine = function (el, id, samples) {
	        var svg = d3.select(el);
	        var x = d3.scaleLinear()
	            .domain([this.props.xmin, this.props.xmax])
	            .range([0, this.width]);
	        var x_no_margs = d3.scaleLinear()
	            .domain([this.props.xmin, this.props.xmax])
	            .range([0, this.ow]);
	        var y = d3.scaleLinear()
	            .domain([this.props.ymin, this.props.ymax])
	            .range([this.height, 0]);
	        var y_no_margs = d3.scaleLinear()
	            .domain([this.props.ymin, this.props.ymax])
	            .range([this.oh, 0]);
	        var curve_no_x = d3.line()
	            .x(function (d) { return x_no_margs(d.x); })
	            .y(function (d) { return y(d.y); });
	        var curve_no_y = d3.line()
	            .x(function (d) { return x(d.x); })
	            .y(function (d) { return y_no_margs(d.y); });
	        var curve = d3.line()
	            .x(function (d) { return x(d.x); })
	            .y(function (d) { return y(d.y); })
	            .curve(d3.curveCatmullRom);
	        var g = svg.select("g.chart-canvas");
	        var no_x_margins = svg.select("g.no-x-margins");
	        var no_y_margins = svg.select("g.no-y-margins");
	        var path = g.select("#" + id);
	        if (path.empty()) {
	            path = g.append("path").attr("id", id);
	        }
	        var x_axis = d3.axisBottom(x)
	            .ticks(Math.floor(this.width / 30), "s");
	        svg.select(".x-axis-bottom")
	            .call(x_axis);
	        var y_axis = d3.axisLeft(y)
	            .ticks(Math.floor(this.height / 30), "s");
	        svg.select(".y-axis-left")
	            .call(y_axis);
	        if (this.props.traceVertical) {
	            var tid = "vtrace-" + id;
	            var vtrace = no_y_margins.select("#" + tid);
	            if (vtrace.empty()) {
	                vtrace = no_y_margins.append("path").attr("id", tid);
	            }
	            var xpos = samples[samples.length - 1].x;
	            var ymin = this.props.ymin;
	            var ymax = this.props.ymax;
	            vtrace.datum([new Geometry_1.Position2(xpos, ymin), new Geometry_1.Position2(xpos, ymax)])
	                .attr("d", curve_no_y)
	                .attr("stroke", "black")
	                .attr("fill", "none")
	                .attr("stroke-width", 1);
	        }
	        if (this.props.traceHorizontal) {
	            var tid = "htrace-" + id;
	            var htrace = no_x_margins.select("#" + tid);
	            if (htrace.empty()) {
	                htrace = no_x_margins.append("path").attr("id", tid);
	            }
	            var ypos = samples[samples.length - 1].y;
	            htrace.datum([new Geometry_1.Position2(this.props.xmin, ypos), new Geometry_1.Position2(this.props.xmax, ypos)])
	                .attr("d", curve_no_x)
	                .attr("stroke", "black")
	                .attr("fill", "none")
	                .attr("stroke-width", 1);
	        }
	        path.datum(samples)
	            .attr("d", curve)
	            .attr("stroke-width", 1)
	            .attr("width", "100%")
	            .attr("height", "100%")
	            .attr("stroke", "blue")
	            .attr("fill", "none");
	    };
	    Plotter.prototype.updateChart = function (el) {
	        var _this = this;
	        this.removeLines(el, this.state.curveUpdates.removeCurves.map(function (c) { return c.key; }));
	        this.state.curveUpdates.updateCurves.forEach(function (curve) {
	            var samples = _this.sample(curve.value);
	            _this.drawOneLine(el, curve.key, _this.sample(curve.value));
	        });
	        this.state.curveUpdates.addCurves.forEach(function (curve) {
	            var samples = _this.sample(curve.value);
	            _this.drawOneLine(el, curve.key, _this.sample(curve.value));
	        });
	    };
	    Plotter.prototype.componentDidMount = function () {
	        this.createChart(ReactDOM.findDOMNode(this));
	    };
	    Plotter.prototype.componentDidUpdate = function () {
	        this.updateChart(ReactDOM.findDOMNode(this));
	    };
	    Plotter.prototype.componentWillReceiveProps = function (newProps) {
	        this.setState({ curveUpdates: this.getIntersections(this.props.curves, newProps.curves) });
	    };
	    Plotter.prototype.render = function () {
	        var id = _.uniqueId("plot-");
	        return React.createElement("svg", { className: "geometry-plotter", dangerouslySetInnerHTML: { __html: "" } });
	    };
	    return Plotter;
	}(Sauce.Component));
	exports.Plotter = Plotter;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(13));
	var Position2 = (function () {
	    function Position2(x, y) {
	        this.x = x;
	        this.y = y;
	    }
	    Position2.prototype.add = function (p) {
	        if (typeof (p) == 'Position2') {
	            return new Position2(this.x + p.x, this.y + p.y);
	        }
	        else if (typeof (p) == 'Size2') {
	            return new Position2(this.x + p.width, this.y + p.height);
	        }
	        else {
	            throw ("Can't add " + typeof (p) + " to Position2");
	        }
	    };
	    return Position2;
	}());
	exports.Position2 = Position2;
	var Vec2 = (function () {
	    function Vec2(x1, x2) {
	        this.x1 = x1;
	        this.x2 = x2;
	    }
	    Vec2.prototype.add = function (v) {
	        return new Vec2(this.x1 + v.x1, this.x2 + v.x2);
	    };
	    return Vec2;
	}());
	exports.Vec2 = Vec2;
	var Size2 = (function () {
	    function Size2(width, height) {
	        this.width = width;
	        this.height = height;
	    }
	    return Size2;
	}());
	exports.Size2 = Size2;
	var Box = (function () {
	    function Box() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (args[0] instanceof Position2) {
	            this.topLeft = args[0],
	                this.bottomRight = args[1];
	        }
	        else {
	            this.topLeft = new Position2(args[0], args[1]),
	                this.bottomRight = new Position2(args[2], args[3]);
	        }
	    }
	    Box.prototype.top = function () { return this.topLeft.y; };
	    Box.prototype.left = function () { return this.topLeft.x; };
	    Box.prototype.right = function () { return this.bottomRight.x; };
	    Box.prototype.bottom = function () { return this.bottomRight.y; };
	    Box.prototype.subset = function (b2) {
	        return Box.subset(this, b2);
	    };
	    Box.subset = function (b1, b2) {
	        return new Box(new Position2(Math.max(b1.topLeft.x, b2.topLeft.x), Math.max(b1.topLeft.y, b2.topLeft.y)), new Position2(Math.min(b1.bottomRight.x, b2.bottomRight.x), Math.min(b1.bottomRight.y, b2.bottomRight.y)));
	    };
	    return Box;
	}());
	exports.Box = Box;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(1376);

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(167);

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	exports.ChartMargins = { top: 10, right: 10, bottom: 30, left: 30 };


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var base32 = __webpack_require__(20);
	function makeDomId(uniqueString) {
	    return "id" + base32.encode(uniqueString);
	}
	exports.makeDomId = makeDomId;
	function merge(partial, obj) {
	    if (true) {
	        for (var name_1 in partial) {
	            if (partial.hasOwnProperty(name_1)) {
	                obj[name_1] = partial[name_1];
	            }
	        }
	        return obj;
	    }
	}
	exports.merge = merge;
	function pick(o) {
	    var keys = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        keys[_i - 1] = arguments[_i];
	    }
	    return keys.reduce(function (acc, k) {
	        if (o.hasOwnProperty(k)) {
	            acc[k] = o[k];
	        }
	        return acc[k];
	    }, {});
	}
	exports.pick = pick;
	function handle_null(maybe, fn, fallback) {
	    if (!maybe) {
	        return fallback;
	    }
	    else {
	        return fn(maybe);
	    }
	}
	exports.handle_null = handle_null;
	function clamp(val, min, max) {
	    var maxxed = Math.min(val, max !== undefined ? max : val);
	    return Math.max(val, min !== undefined ? min : maxxed);
	}
	exports.clamp = clamp;
	var canvas = null;
	function getTextWidth(text, font, document) {
	    if (!canvas) {
	        canvas = document.createElement("canvas");
	    }
	    var context = canvas.getContext("2d");
	    context.font = font;
	    var metrics = context.measureText(text);
	    return metrics.width;
	}
	exports.getTextWidth = getTextWidth;


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(697);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(22);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./MasonDotNet.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./MasonDotNet.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, "ul.math-showcase{list-style:none}.lissajous{display:inline-block;width:200px;height:200px}", ""]);
	
	// exports


/***/ },
/* 23 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(2);
	var Sauce = __webpack_require__(7);
	var $ = __webpack_require__(17);
	var ReactDOM = __webpack_require__(4);
	var Oscilloscope_1 = __webpack_require__(26);
	__webpack_require__(32);
	$(document).ready(function () {
	    var p = document.getElementById("parametric");
	    if (p) {
	        ReactDOM.render(React.createElement(Parametric), p);
	    }
	});
	var Parametric = (function (_super) {
	    __extends(Parametric, _super);
	    function Parametric(props) {
	        var _this = _super.call(this, props) || this;
	        _this.receiveNewOscProps = function (props) {
	            _this.setState({ osc: props });
	        };
	        var initial_state = { osc: undefined };
	        _this.state = initial_state;
	        return _this;
	    }
	    Parametric.prototype.render = function () {
	        var osc;
	        if (this.state.osc && this.state.osc.curve) {
	            osc = React.createElement(Oscilloscope_1.Oscilloscope, { key: "osc1", curve: this.state.osc.curve, tmin: this.state.osc.tmin, tmax: this.state.osc.tmax, xmin: this.state.osc.xmin, xmax: this.state.osc.xmax, ymin: this.state.osc.ymin, ymax: this.state.osc.ymax, autoplay: true, repeat: this.state.osc.repeat, duration: this.state.osc.duration, repeatDelay: this.state.osc.repeatDelay, numSamples: 1000 });
	        }
	        else {
	            osc = React.createElement("div", { className: "error-msg" }, "Invalid curve, can't graph");
	        }
	        return React.createElement("div", { className: "parametric-root" },
	            osc,
	            React.createElement("div", null,
	                "These expressions are parsed using ",
	                React.createElement("a", { href: "http://mathjs.org/docs/expressions/syntax.html" }, "mathjs")),
	            React.createElement(Oscilloscope_1.OscilloscopeController, { flush: this.receiveNewOscProps, autoplay: true, startx: "sin(t) * (e^cos(t) - 2 * cos(4t) - sin(t/12)^6)", starty: "cos(t) * (e^cos(t) - 2 * cos(4t) - sin(t/12)^6)", tmin: "-6 * pi", tmax: "6 * pi", xmin: "-5", xmax: "5", ymin: -5, ymax: 5, repeat: true, duration: "10 * 1000", repeatDelay: 3000, numSamples: 500 }));
	    };
	    return Parametric;
	}(Sauce.Component));
	exports.Parametric = Parametric;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(2);
	var math = __webpack_require__(27);
	var Rx = __webpack_require__(9);
	var Sauce = __webpack_require__(7);
	var Validation = __webpack_require__(12);
	var UIConstants_1 = __webpack_require__(18);
	var Plotter_1 = __webpack_require__(14);
	var ParametricCurve_1 = __webpack_require__(13);
	var AnimationHelper_1 = __webpack_require__(28);
	var Util_1 = __webpack_require__(19);
	var Form_1 = __webpack_require__(10);
	var Basic_1 = __webpack_require__(29);
	__webpack_require__(30);
	;
	var prev_curve_id = "";
	var FormulaInput = (function (_super) {
	    __extends(FormulaInput, _super);
	    function FormulaInput() {
	        return _super.apply(this, arguments) || this;
	    }
	    return FormulaInput;
	}(Form_1.TextAreaInput));
	var OscilloscopeController = (function (_super) {
	    __extends(OscilloscopeController, _super);
	    function OscilloscopeController(props) {
	        var _this = _super.call(this, props) || this;
	        _this.formulaProcessorFactory = new Validation.ValueProcessorFactory(function (formatted) { return _this.compile(formatted); }, undefined, undefined, undefined, function (raw) { return raw.replace(/\n\r?/, ""); });
	        _this.formula_validator = _this.formulaProcessorFactory.make();
	        _this.samp_validator = new Basic_1.RoundingInteger(50, 10000).make();
	        _this.duration_validator = new Basic_1.RoundingInteger(0, 1000 * 60 * 15).make();
	        _this.t_min_validator = new Basic_1.Real(4, -100 * Math.PI, 100 * Math.PI).make();
	        _this.t_max_validator = new Basic_1.Real(4, -100 * Math.PI, 100 * Math.PI).make();
	        _this.bool_validator = new Basic_1.CheckboxValue().make();
	        _this.real_validator = new Basic_1.Real().make();
	        _this.flush = function (partial) {
	            var state = _this.collateState(partial);
	            if (_this.all_valid(state)) {
	                var props = _this.collateProps(state);
	                _this.props.flush(props);
	            }
	        };
	        _this.state = {
	            formula_x: _this.formula_validator(props.startx),
	            formula_y: _this.formula_validator(props.starty),
	            samples: _this.samp_validator(props.numSamples),
	            duration: _this.duration_validator(props.duration),
	            repeat: _this.bool_validator(props.repeat),
	            repeatDelay: props.repeatDelay,
	            tmin: _this.t_min_validator(props.tmin),
	            tmax: _this.t_max_validator(props.tmax),
	            xmin: _this.real_validator(props.xmin),
	            xmax: _this.real_validator(props.xmax),
	            ymin: _this.real_validator(props.ymin),
	            ymax: _this.real_validator(props.ymax)
	        };
	        return _this;
	    }
	    OscilloscopeController.prototype.curve_id = function (x, y) {
	        return Util_1.makeDomId(x.formatted + "___" + y.formatted);
	    };
	    OscilloscopeController.prototype.combine_curves = function (x, y) {
	        if (x.value && y.value) {
	            var curve = new ParametricCurve_1.SimpleParametricCurve2(x.value, y.value);
	            var idc = {
	                key: this.curve_id(x, y),
	                value: curve
	            };
	            return idc;
	        }
	        return null;
	    };
	    OscilloscopeController.prototype.collateState = function (partial) {
	        return Object.assign({}, this.state, partial);
	    };
	    OscilloscopeController.prototype.collateProps = function (state) {
	        var props = {};
	        for (var _i = 0, _a = Object.keys(state); _i < _a.length; _i++) {
	            var key = _a[_i];
	            var val = state[key];
	            if (key === "curve") { }
	            else if (val instanceof Validation.ParseResult) {
	                props[key] = val.value;
	            }
	            else {
	                props[key] = val;
	            }
	        }
	        var curve = this.combine_curves(state.formula_x, state.formula_y);
	        if (curve && curve.key !== prev_curve_id) {
	            props.curve = curve;
	        }
	        return props;
	    };
	    OscilloscopeController.prototype.all_valid = function (state) {
	        for (var _i = 0, _a = Object.keys(state); _i < _a.length; _i++) {
	            var key = _a[_i];
	            var val = state[key];
	            if (val instanceof Validation.ParseResult && !val.valid)
	                return false;
	        }
	        return true;
	    };
	    OscilloscopeController.prototype.propagate = function (partial) {
	        this.setState(partial);
	        this.flush(this.collateState(partial));
	    };
	    OscilloscopeController.prototype.componentWillMount = function () {
	        var props = this.collateState({});
	        this.flush(props);
	    };
	    OscilloscopeController.prototype.compile = function (input) {
	        var compile = math.parse(input).compile();
	        return function (t) { return compile.eval({ t: t }); };
	    };
	    OscilloscopeController.prototype.render = function () {
	        var _this = this;
	        return React.createElement("div", { className: "geometroy-oscilloscope-controller" },
	            React.createElement("div", { className: "x-formula" },
	                React.createElement("label", null, "x signal function"),
	                React.createElement(FormulaInput, { value: this.state.formula_x, processor: this.formula_validator, flush: function (val) { return _this.propagate({ formula_x: val }); } }),
	                React.createElement("label", { className: "error-message" }, this.state.formula_x.errorMsg)),
	            React.createElement("div", { className: "y-formula" },
	                React.createElement("label", null, "y signal function"),
	                React.createElement(FormulaInput, { value: this.state.formula_y, processor: this.formula_validator, flush: function (val) { return _this.propagate({ formula_y: val }); } }),
	                React.createElement("label", { className: "error-message" }, this.state.formula_y.errorMsg)),
	            React.createElement("div", { className: "repeat" },
	                React.createElement("label", null, "Repeat"),
	                React.createElement(Form_1.Checkbox, { initialValue: this.state.repeat, processor: new Validation.ValueProcessorFactory().make(), flush: function (val) { return _this.propagate({ repeat: val }); } })),
	            React.createElement("div", { className: "duration" },
	                React.createElement("label", null, "Animation Duration (ms)"),
	                React.createElement(Form_1.NumberInput, { value: this.state.duration, processor: this.duration_validator, flush: function (val) { return _this.propagate({ duration: val }); } }),
	                React.createElement("label", { className: "error-message", content: this.state.duration.errorMsg })),
	            React.createElement("div", { className: "samples" },
	                React.createElement("label", null, "How often should we sample the curve"),
	                React.createElement(Form_1.NumberInput, { value: this.state.samples, processor: this.samp_validator, flush: function (val) { return _this.propagate({ samples: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.samples.errorMsg })),
	            React.createElement("div", { className: "t-min" },
	                React.createElement("label", null, "tmin: start animating at tmin"),
	                React.createElement(Form_1.NumberInput, { value: this.state.tmin, processor: this.real_validator, flush: function (val) { return _this.propagate({ tmin: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.tmin.errorMsg })),
	            React.createElement("div", { className: "t-max" },
	                React.createElement("label", null, "tmax: stop animating at tmax"),
	                React.createElement(Form_1.NumberInput, { value: this.state.tmax, processor: this.real_validator, flush: function (val) { return _this.propagate({ tmax: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.tmax.errorMsg })),
	            React.createElement("div", { className: "x-min" },
	                React.createElement("label", null, "x min"),
	                React.createElement(Form_1.NumberInput, { value: this.state.xmin, processor: this.real_validator, flush: function (val) { return _this.propagate({ xmin: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.xmin.errorMsg })),
	            React.createElement("div", { className: "x-max" },
	                React.createElement("label", null, "x max"),
	                React.createElement(Form_1.NumberInput, { value: this.state.xmax, processor: this.real_validator, flush: function (val) { return _this.propagate({ xmax: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.xmax.errorMsg })),
	            React.createElement("div", { className: "y-min" },
	                React.createElement("label", null, "y min"),
	                React.createElement(Form_1.NumberInput, { value: this.state.ymin, processor: this.real_validator, flush: function (val) { return _this.propagate({ ymin: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.ymin.errorMsg })),
	            React.createElement("div", { className: "y-max" },
	                React.createElement("label", null, "y max"),
	                React.createElement(Form_1.NumberInput, { value: this.state.ymax, processor: this.real_validator, flush: function (val) { return _this.propagate({ ymax: val }); } }),
	                React.createElement("label", { className: "error-message", value: this.state.ymax.errorMsg })));
	    };
	    return OscilloscopeController;
	}(Sauce.Component));
	exports.OscilloscopeController = OscilloscopeController;
	var Oscilloscope = (function (_super) {
	    __extends(Oscilloscope, _super);
	    function Oscilloscope(props) {
	        var _this = _super.call(this, props) || this;
	        _this.numSamples = 100;
	        _this.margins = UIConstants_1.ChartMargins;
	        _this.ah = new AnimationHelper_1.AnimationHelper(3000, 60);
	        _this.paused = !props.autoplay;
	        _this.pauser = new Rx.BehaviorSubject(_this.paused);
	        _this.state = {
	            tend: _this.props.tmin,
	            ycurve: _this.makeycurve(_this.props.curve),
	            xcurve: _this.makexcurve(_this.props.curve)
	        };
	        _this.togglePause = _this.togglePause.bind(_this);
	        return _this;
	    }
	    Oscilloscope.prototype.getClock = function (props) {
	        return new AnimationHelper_1.AnimationHelper(props.duration, 60).simpleTicker(props.tmin, props.tmax, props.repeat, props.repeatDelay, this.pauser);
	    };
	    Oscilloscope.prototype.startAnimating = function (clock) {
	        var _this = this;
	        return this.subscribe(clock, function (t) {
	            _this.setState({ tend: t });
	        });
	    };
	    Oscilloscope.prototype.restartAnimation = function (props) {
	        this.remove(this.clockSub);
	        this.clockSub = this.startAnimating(this.getClock(props));
	    };
	    Oscilloscope.prototype.componentDidMount = function () {
	        this.clockSub = this.startAnimating(this.getClock(this.props));
	    };
	    Oscilloscope.prototype.animation_parameters_changed = function (prev, next) {
	        var oldcurve = prev.curve && prev.curve.key;
	        var newcurve = next.curve && next.curve.key;
	        return prev.duration !== next.duration
	            || prev.repeat !== next.repeat
	            || prev.repeatDelay !== next.repeatDelay
	            || prev.tmin !== next.tmin
	            || prev.tmax !== next.tmax
	            || prev.repeat !== next.repeat
	            || oldcurve !== newcurve;
	    };
	    Oscilloscope.prototype.componentWillReceiveProps = function (newProps) {
	        var oldcurve = this.props.curve && this.props.curve.key;
	        var newcurve = newProps.curve && newProps.curve.key;
	        if (oldcurve !== newcurve) {
	            this.setState(Util_1.merge({
	                ycurve: this.makeycurve(newProps.curve),
	                xcurve: this.makexcurve(newProps.curve)
	            }, this.state));
	        }
	        if (this.animation_parameters_changed(this.props, newProps)) {
	            this.restartAnimation(newProps);
	        }
	    };
	    Oscilloscope.prototype.makeycurve = function (mainCurve) {
	        if (mainCurve != undefined) {
	            return { key: "ycurve" + mainCurve.key, value: new ParametricCurve_1.SimpleParametricCurve2(function (t) { return t; }, function (t) { return mainCurve.value.y(t); }) };
	        }
	        return null;
	    };
	    Oscilloscope.prototype.makexcurve = function (mainCurve) {
	        if (mainCurve != undefined) {
	            return { key: "xcurve" + mainCurve.key, value: new ParametricCurve_1.SimpleParametricCurve2(function (t) { return mainCurve.value.x(t); }, function (t) { return t; }) };
	        }
	        return null;
	    };
	    Oscilloscope.prototype.togglePause = function () {
	        this.paused = !this.paused;
	        this.pauser.next(this.paused);
	    };
	    Oscilloscope.prototype.render = function () {
	        return React.createElement("div", { className: "geometry-component-oscilloscope", onClick: this.togglePause },
	            React.createElement("div", { className: "y-curve" },
	                React.createElement(Plotter_1.Plotter, { curves: this.state.ycurve ? [this.state.ycurve] : [], tmin: this.props.tmin, tmax: this.state.tend, xmin: this.props.tmin, xmax: this.props.tmax, ymin: this.props.ymin, ymax: this.props.ymax, numSamples: this.props.numSamples, traceHorizontal: true })),
	            React.createElement("div", { className: "x-curve" },
	                React.createElement(Plotter_1.Plotter, { curves: this.state.xcurve ? [this.state.xcurve] : [], tmin: this.props.tmin, tmax: this.state.tend, xmin: this.props.xmin, xmax: this.props.xmax, ymin: this.props.tmin, ymax: this.props.tmax, numSamples: this.props.numSamples, traceVertical: true })),
	            React.createElement("div", { className: "main-curve" },
	                React.createElement(Plotter_1.Plotter, { curves: this.props.curve ? [this.props.curve] : [], tmin: this.props.tmin, tmax: this.state.tend, xmin: this.props.xmin, xmax: this.props.xmax, ymin: this.props.ymin, ymax: this.props.ymax, numSamples: this.props.numSamples * 5, traceVertical: true, traceHorizontal: true })));
	    };
	    return Oscilloscope;
	}(Sauce.Component));
	exports.Oscilloscope = Oscilloscope;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(168);

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var rxjs_1 = __webpack_require__(9);
	var AnimationHelper = (function () {
	    function AnimationHelper(duration, fps) {
	        if (fps === void 0) { fps = 60; }
	        this.duration = duration;
	        this.fps = fps;
	        this.numFrames = (this.duration / 1000) * this.fps;
	        this.numIntervals = this.numFrames - 1;
	    }
	    AnimationHelper.prototype.increment = function (v_initial, v_final) {
	        var distance = v_final - v_initial;
	        var rv = [];
	        var increment = distance / this.numIntervals;
	        return increment;
	    };
	    AnimationHelper.prototype.pausableDelay = function (paused, ms) {
	        return rxjs_1.Observable.create(function (obs) {
	            var i = 0;
	            var ticker = rxjs_1.Observable.interval(50).map(function () { return i += 50; });
	            var inner = new rxjs_1.Subscriber(undefined, undefined, function () { return obs.complete(); });
	            var paus = paused ? paused : rxjs_1.Observable.of(false);
	            return paus.switchMap(function (paused) { return paused ? rxjs_1.Observable.never() : ticker; })
	                .takeWhile(function (val) { return val <= ms; })
	                .subscribe(inner);
	        });
	    };
	    AnimationHelper.prototype.pausableInterval = function (paused) {
	        var _this = this;
	        return rxjs_1.Observable.create(function (obs) {
	            var i = 0;
	            var ticker = rxjs_1.Observable.interval(1000 / _this.fps).map(function () { return i++; });
	            var p = paused.switchMap(function (paused) { return paused ? rxjs_1.Observable.never() : ticker; });
	            return p.subscribe(function (val) { return obs.next(val); }, function (err) { return obs.error(err); }, function () { return obs.complete(); });
	        });
	    };
	    AnimationHelper.prototype.clock = function (repeat, repeatDelay, pauseSignal) {
	        var _this = this;
	        var int = pauseSignal ? this.pausableInterval(pauseSignal) : rxjs_1.Observable.interval(1000 / this.fps);
	        var rx = int
	            .map(function (i) { return i + 1; })
	            .startWith(0)
	            .takeWhile(function (i) { return i < _this.numFrames; });
	        if (repeat) {
	            if (typeof repeatDelay !== 'undefined') {
	                rx = rx.concat(this.pausableDelay(pauseSignal, repeatDelay));
	            }
	            rx = rx.repeat(-1);
	        }
	        return rx;
	    };
	    AnimationHelper.prototype.tickThrough = function (clock, start, increment) {
	        var v = clock.zip(rxjs_1.Observable.from(["a, b, c"])).map(function (v) { return v[1]; });
	        return clock.map(function (t) { return start + (t * increment); });
	    };
	    AnimationHelper.simpleTicker = function (start, end, duration, repeat, repeatDelay, pauseSignal, fps) {
	        if (fps === void 0) { fps = 60; }
	        var ah = new AnimationHelper(duration, fps);
	        return ah.simpleTicker(start, end, repeat, repeatDelay, pauseSignal);
	    };
	    AnimationHelper.prototype.simpleTicker = function (start, end, repeat, repeatDelay, pauseSignal) {
	        var clock = this.clock(repeat, repeatDelay, pauseSignal);
	        var inc = this.increment(start, end);
	        return this.tickThrough(clock, start, inc);
	    };
	    return AnimationHelper;
	}());
	exports.AnimationHelper = AnimationHelper;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Validation = __webpack_require__(12);
	var Util_1 = __webpack_require__(19);
	var mathjs = __webpack_require__(27);
	var _ = __webpack_require__(11);
	var RoundingInteger = (function (_super) {
	    __extends(RoundingInteger, _super);
	    function RoundingInteger(min, max) {
	        var _this = _super.call(this) || this;
	        _this.min = min;
	        _this.max = max;
	        _this.fac = new Validation.ValueProcessorFactory(function (formatted) { return Util_1.clamp(Math.round(mathjs.eval(formatted)), min, max); }, function (val) { return !_.isFinite(val) ? "Not a finite number" : ""; }, function (val) { return val.toString(); });
	        return _this;
	    }
	    RoundingInteger.prototype.make = function () {
	        return this.fac.make();
	    };
	    return RoundingInteger;
	}(Validation.ValueProcessorFactory));
	exports.RoundingInteger = RoundingInteger;
	var CheckboxValue = (function (_super) {
	    __extends(CheckboxValue, _super);
	    function CheckboxValue() {
	        return _super.call(this, function (formatted) { return formatted ? true : false; }) || this;
	    }
	    return CheckboxValue;
	}(Validation.ValueProcessorFactory));
	exports.CheckboxValue = CheckboxValue;
	var Real = (function (_super) {
	    __extends(Real, _super);
	    function Real(precision, min, max) {
	        var _this = _super.call(this) || this;
	        _this.precision = precision;
	        _this.min = min;
	        _this.max = max;
	        _this.fac = new Validation.ValueProcessorFactory(function (formatted) { return Util_1.clamp(mathjs.eval(formatted), min, max); }, function (val) { return !_.isFinite(val) ? "Not a finite number" : ""; }, function (val, raw) { return _.isFinite(val) ? val.toPrecision(precision) : raw; });
	        return _this;
	    }
	    Real.prototype.make = function () {
	        return this.fac.make();
	    };
	    return Real;
	}(Validation.ValueProcessorFactory));
	exports.Real = Real;
	var RealExpression = (function (_super) {
	    __extends(RealExpression, _super);
	    function RealExpression(precision, min, max) {
	        var _this = _super.call(this) || this;
	        _this.precision = precision;
	        _this.min = min;
	        _this.max = max;
	        _this.fac = new Validation.ValueProcessorFactory(function (formatted) { return Util_1.clamp(mathjs.eval(formatted), min, max); }, function (val) { return !_.isFinite(val) ? "Not a finite number" : ""; }, function (_, raw) { return raw; });
	        return _this;
	    }
	    RealExpression.prototype.make = function () {
	        return this.fac.make();
	    };
	    return RealExpression;
	}(Validation.ValueProcessorFactory));
	exports.RealExpression = RealExpression;
	exports.AnyReal = new Real().make();
	exports.AnyRealExpression = new RealExpression().make();
	var Label = (function (_super) {
	    __extends(Label, _super);
	    function Label(process, postvalidate, format, prevalidate, preformat) {
	        var _this = _super.call(this) || this;
	        _this.process = process;
	        _this.postvalidate = postvalidate;
	        _this.format = format;
	        _this.prevalidate = prevalidate;
	        _this.preformat = preformat;
	        _this.fac = new Validation.ValueProcessorFactory(_this.process, _this.postvalidate, _this.format, _this.prevalidate, _this.preformat);
	        return _this;
	    }
	    Label.prototype.make = function () {
	        return this.fac.make();
	    };
	    return Label;
	}(Validation.ValueProcessorFactory));
	exports.Label = Label;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(31);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./Oscilloscope.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./Oscilloscope.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, ".geometry-component-oscilloscope{display:block;max-width:600px;width:100%;height:600px;position:relative}.geometry-component-oscilloscope .main-curve{position:absolute;right:0;top:0;left:33.33333%;bottom:33.33333%;cursor:pointer}.geometry-component-oscilloscope .x-curve,.geometry-component-oscilloscope .y-curve{position:absolute}.geometry-component-oscilloscope .y-curve{top:0;right:66.66667%;left:0;bottom:33.33333%}.geometry-component-oscilloscope .x-curve{top:66.66667%;right:0;bottom:0;left:33.33333%}.geometroy-oscilloscope-controller>div{position:relative;width:100%;min-height:3em}.geometroy-oscilloscope-controller>* label,.geometroy-oscilloscope-controller input,.geometroy-oscilloscope-controller textarea{position:absolute;box-sizing:border-box;display:inline-block;top:0;bottom:2px}.geometroy-oscilloscope-controller>* label{left:0;display:flex;width:25%;justify-content:center;flex-direction:column}.geometroy-oscilloscope-controller>* label.error-message{left:75%;padding:2px}.geometroy-oscilloscope-controller>* textarea,.geometroy-oscilloscope-controller input{left:25%;width:50%;resize:none}", ""]);
	
	// exports


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(33);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./Parametric.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./Parametric.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, ".parametric-root{width:100%;max-width:600px;height:600px;margin:0 auto}", ""]);
	
	// exports


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(2);
	var Sauce = __webpack_require__(7);
	var Graph_1 = __webpack_require__(35);
	var GraphBuilder_1 = __webpack_require__(37);
	var MatrixViewer_1 = __webpack_require__(45);
	var reactstrap_1 = __webpack_require__(40);
	var Form_1 = __webpack_require__(10);
	var Matrix_1 = __webpack_require__(71);
	var Matrix_2 = __webpack_require__(36);
	var Basic_1 = __webpack_require__(29);
	var d3 = __webpack_require__(16);
	var MarkovText = (function (_super) {
	    __extends(MarkovText, _super);
	    function MarkovText(props) {
	        var _this = _super.call(this, props) || this;
	        _this.toggle = function () {
	            _this.setState({ open: !_this.state.open });
	        };
	        _this.state = { open: false };
	        return _this;
	    }
	    MarkovText.prototype.render = function () {
	        return React.createElement("div", null,
	            React.createElement(reactstrap_1.Button, { onClick: this.toggle, style: { marginBottom: '1rem' } }, this.state.open ? "Hide" : "Show"),
	            React.createElement(reactstrap_1.Collapse, { isOpen: this.state.open },
	                React.createElement("div", { className: "markov" }, "A markov chain can be represented as a graph." + " " + "Each node in the graph is a possible state that the system can have." + " " + "Each edge of the graph is a transition probability from one state to another." + " " + "In mathematics this kind of graph is also known as a stochastic process." + " " + "A markov chain can also be represented as the adjacency matrix of a markov graph. This representation allows us to do useful linear algebra and discover some latent properties of markov chains.")));
	    };
	    return MarkovText;
	}(Sauce.Component));
	;
	var MarkovGraphViewer = (function (_super) {
	    __extends(MarkovGraphViewer, _super);
	    function MarkovGraphViewer() {
	        return _super.apply(this, arguments) || this;
	    }
	    return MarkovGraphViewer;
	}(MatrixViewer_1.MatrixViewer));
	var Markov = (function (_super) {
	    __extends(Markov, _super);
	    function Markov(props) {
	        var _this = _super.call(this, props) || this;
	        _this.graphChanged = function (g) {
	            if (g.order() > _this.state.stateVector.rows) {
	                _this.setState({ stateVector: _this.state.stateVector.grow(g.order() - _this.state.stateVector.rows) });
	            }
	            else if (g.order() < _this.state.stateVector.rows) {
	                _this.setState({ stateVector: _this.state.stateVector.shrink(_this.state.stateVector.rows - g.order()) });
	            }
	            _this.forceUpdate();
	        };
	        var params = props.params;
	        _this.state = {
	            stateVector: Matrix_2.Matrix.make(0, 1, function () { return Basic_1.AnyReal(0); }, function (_) { return _.formatted ? _.formatted : _.raw; }),
	            matrixPower: Basic_1.AnyReal(1)
	        };
	        var matrix = Matrix_2.Matrix.make(0, 1, function () { return Basic_1.AnyReal(0); }, function (_) { return _.value.toPrecision(3); });
	        if (params.graphSerialization) {
	            _this.graph = Graph_1.EdgeWeightedAdjacencyMatrixGraph.deserialize(params.graphSerialization);
	        }
	        else {
	            _this.graph = new Graph_1.EdgeWeightedAdjacencyMatrixGraph(function () { return ({ weight: 0, weightParseResult: Basic_1.AnyReal(0) }); });
	        }
	        return _this;
	    }
	    Markov.prototype.componentDidMount = function () {
	        this.subscribe(this.graph.graphChanged, this.graphChanged);
	    };
	    Markov.prototype.componentWillReceiveProps = function (newProps) {
	        var _this = this;
	        var params = newProps.params;
	        var graph = this.graph;
	        if (params.graphSerialization) {
	        }
	        if (this.graph !== graph) {
	            this.graph = graph;
	            if (this.graphSubscription) {
	                this.remove(this.graphSubscription);
	            }
	            if (graph) {
	                this.graphSubscription = this.subscribe(this.graph.graphChanged, function (g) { return _this.forceUpdate(); });
	            }
	        }
	    };
	    Markov.prototype.componentWillUnmount = function () {
	        if (this.graphSubscription) {
	            this.remove(this.graphSubscription);
	        }
	    };
	    Markov.prototype.render = function () {
	        var _this = this;
	        var _a = this, props = _a.props, graph = _a.graph;
	        var copy = graph.getMatrixCopy();
	        var size = 75;
	        var nodecount = copy.rows;
	        var entries = graph.rawMatrixEntries();
	        var columnLabels = d3.range(0, copy.cols).map(function (idx) { return graph.getNode(idx).label; });
	        var copyNumeric = copy.map(function (e) { return e.weight; });
	        var multipiedCopy = d3.range(this.state.matrixPower.value).reduce(function (prev) { return prev.multiply(copyNumeric); }, copyNumeric.map(function (_, i, j) { return i === j ? 1 : 0; }));
	        var multiplicationResult = multipiedCopy.multiply(this.state.stateVector.map(function (e) { return e.value; }));
	        var displayResult = multiplicationResult.map(function (n) { return Basic_1.AnyReal(n); });
	        return React.createElement("div", { className: "markov-container" },
	            React.createElement(MarkovText, null),
	            React.createElement(GraphBuilder_1.GraphBuilder, { graph: this.graph }),
	            React.createElement("div", { style: { display: 'flex' } },
	                React.createElement(Matrix_1.NumericMatrix, { matrix: copy.map(function (e) { return e.weightParseResult; }), columnLabels: columnLabels, leftRowLabels: columnLabels, outerHeight: (nodecount + 1) * 75, outerWidth: (nodecount + 1) * 75, flush: function (i, j, val) { return _this.graph.setEdgeByIndex(i, j, { weight: val.value, weightParseResult: val }); } }),
	                React.createElement("div", null,
	                    React.createElement("label", null, "^"),
	                    React.createElement(Form_1.NumberInput, { style: { width: 40 }, value: this.state.matrixPower, flush: function (val) { return _this.setState({ matrixPower: val }); }, processor: Basic_1.AnyRealExpression })),
	                React.createElement(Matrix_1.NumericMatrix, { matrix: this.state.stateVector, outerHeight: (nodecount + 1) * 75, outerWidth: 2 * 75, rightRowLabels: columnLabels, columnLabels: ["initial state"], flush: function (i, j, val) { return _this.setState({ stateVector: _this.state.stateVector.setEntry(i, j, val) }); } })),
	            React.createElement(Matrix_1.NumericMatrix, { matrix: displayResult, leftRowLabels: columnLabels, outerHeight: multiplicationResult.rows * size, outerWidth: (multiplicationResult.cols + 1) * size }));
	    };
	    return Markov;
	}(Sauce.Component));
	exports.Markov = Markov;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Rx = __webpack_require__(9);
	var Util = __webpack_require__(19);
	var base32 = __webpack_require__(20);
	var Matrix_1 = __webpack_require__(36);
	var AdjacencyMatrixGraph = (function () {
	    function AdjacencyMatrixGraph(filler, pretty) {
	        this.idxes = {};
	        this.nodeIds = {};
	        this.data = {};
	        this.nextIdCounter = 0;
	        this.graphChanged = new Rx.BehaviorSubject(this);
	        this.matrix = Matrix_1.Matrix.make(0, 0, filler, pretty ? pretty : function (e) { return JSON.stringify(e); });
	    }
	    AdjacencyMatrixGraph.prototype.getEdge = function (fromId, toId) {
	        var colIdx = this.idxes[fromId];
	        var rowIdx = this.idxes[toId];
	        return this.matrix.getEntry(rowIdx, colIdx);
	    };
	    AdjacencyMatrixGraph.prototype.getNodeIds = function () {
	        var _this = this;
	        return Object.keys(this.nodeIds).map(function (k) { return _this.nodeIds[k]; });
	    };
	    AdjacencyMatrixGraph.prototype.getMatrixCopy = function () {
	        return this.matrix.clone();
	    };
	    AdjacencyMatrixGraph.prototype.rawMatrixEntries = function () {
	        return this.matrix.raw;
	    };
	    AdjacencyMatrixGraph.prototype.getNonNullEdges = function () {
	        var edges = [];
	        for (var i = 0; i < this.matrix.rows; i++) {
	            for (var j = 0; j < this.matrix.cols; j++) {
	                var entry = this.matrix.getEntry(i, j);
	                if (entry != null) {
	                    var _c = [this.nodeIds[i], this.nodeIds[j]], i_id = _c[0], j_id = _c[1];
	                    var from = this.data[i_id];
	                    var to = this.data[j_id];
	                    edges.push({ from: j_id, to: i_id, val: entry });
	                }
	            }
	        }
	        return edges;
	    };
	    AdjacencyMatrixGraph.prototype.nextIdNumber = function () {
	        return this.nextIdCounter;
	    };
	    AdjacencyMatrixGraph.prototype.addNode = function (id, payload, fill) {
	        var idx = this.order();
	        this.nextIdCounter++;
	        this.idxes[id] = idx;
	        this.nodeIds[idx] = id;
	        if (payload != undefined) {
	            this.data[id] = payload;
	        }
	        this.matrix.grow(1, 1, fill);
	        this.graphChanged.next(this);
	        return idx;
	    };
	    AdjacencyMatrixGraph.prototype.removeNode = function (id) {
	        var _id = typeof id === "string" ? [id] : id;
	        for (var _i = 0, _id_1 = _id; _i < _id_1.length; _i++) {
	            var id_1 = _id_1[_i];
	            var idx = this.idxes[id_1];
	            if (idx != undefined) {
	                delete this.idxes[id_1];
	                delete this.nodeIds[idx];
	                delete this.data[id_1];
	                this.matrix.removeRows(idx);
	                for (var i = idx; i < this.matrix.rows; i++) {
	                    this.nodeIds[i] = this.nodeIds[i + 1];
	                }
	                delete this.nodeIds[this.matrix.rows];
	                for (var i = idx; i < this.matrix.rows; i++) {
	                    this.idxes[this.nodeIds[i]] -= 1;
	                }
	                delete this.idxes[this.nodeIds[this.matrix.rows]];
	                this.matrix.removeColumns(idx);
	            }
	        }
	        this.graphChanged.next(this);
	    };
	    AdjacencyMatrixGraph.prototype.serialize = function () {
	        return base32.encode(JSON.stringify({
	            idxes: this.idxes,
	            nodeIds: this.nodeIds,
	            data: this.data,
	            matrix: this.matrix.serialize(),
	            nextIdCounter: this.nextIdCounter
	        }));
	    };
	    AdjacencyMatrixGraph.deserialize = function (serialization) {
	        var data = JSON.parse(base32.decode(serialization));
	        var graph = new AdjacencyMatrixGraph(function () { return null; });
	        graph.idxes = data.idxes;
	        graph.nodeIds = data.nodeIds;
	        graph.data = data.data;
	        graph.matrix = Matrix_1.Matrix.deserialize(data.matrix);
	        graph.nextIdCounter = data.nextIdCounter;
	        return graph;
	    };
	    AdjacencyMatrixGraph.prototype.pretty = function (formatter) {
	        return this.matrix.pretty(formatter);
	    };
	    AdjacencyMatrixGraph.prototype._setEdge = function (a, b, e) {
	        this.matrix.setEntry(this.index(b), this.index(a), e);
	    };
	    AdjacencyMatrixGraph.prototype.setEdgeByIndex = function (i, j, val) {
	        this.matrix.setEntry(i, j, val);
	        this.graphChanged.next(this);
	    };
	    AdjacencyMatrixGraph.prototype.setEdge = function (a, b, e) {
	        if (a instanceof Array) {
	            if (b instanceof Array) {
	                for (var _i = 0, a_1 = a; _i < a_1.length; _i++) {
	                    var _a = a_1[_i];
	                    for (var _c = 0, b_1 = b; _c < b_1.length; _c++) {
	                        var _b = b_1[_c];
	                        this._setEdge(_a, _b, e);
	                    }
	                }
	            }
	            else {
	                for (var _d = 0, a_2 = a; _d < a_2.length; _d++) {
	                    var _a = a_2[_d];
	                    this._setEdge(_a, b, e);
	                }
	            }
	        }
	        else {
	            if (b instanceof Array) {
	                for (var _e = 0, b_2 = b; _e < b_2.length; _e++) {
	                    var _b = b_2[_e];
	                    this._setEdge(a, _b, e);
	                }
	            }
	            else {
	                this._setEdge(a, b, e);
	            }
	        }
	        this.graphChanged.next(this);
	    };
	    AdjacencyMatrixGraph.prototype.getNodeById = function (id) {
	        return this.data[id];
	    };
	    AdjacencyMatrixGraph.prototype.getNode = function (idx) {
	        return this.data[this.nodeIds[idx]];
	    };
	    AdjacencyMatrixGraph.prototype.setNode = function (id, data) {
	        this.data[id] = Util.merge(data, this.data[id]);
	        this.graphChanged.next(this);
	    };
	    AdjacencyMatrixGraph.prototype.id = function (idx) {
	        var id = this.nodeIds[idx];
	        if (id === undefined) {
	            throw RangeError("No id for this index");
	        }
	        return this.nodeIds[idx];
	    };
	    AdjacencyMatrixGraph.prototype.index = function (id) {
	        var idx = this.idxes[id];
	        if (idx === undefined) {
	            throw "Unknown id (" + id + ")";
	        }
	        return idx;
	    };
	    AdjacencyMatrixGraph.prototype.order = function () {
	        return this.matrix.rows;
	    };
	    AdjacencyMatrixGraph.prototype.degree = function () {
	        throw "NYI";
	    };
	    return AdjacencyMatrixGraph;
	}());
	exports.AdjacencyMatrixGraph = AdjacencyMatrixGraph;
	var EdgeWeightedAdjacencyMatrixGraph = (function (_super) {
	    __extends(EdgeWeightedAdjacencyMatrixGraph, _super);
	    function EdgeWeightedAdjacencyMatrixGraph() {
	        return _super.apply(this, arguments) || this;
	    }
	    EdgeWeightedAdjacencyMatrixGraph.deserialize = function (serialization) {
	        var data = JSON.parse(base32.decode(serialization));
	        var graph = new EdgeWeightedAdjacencyMatrixGraph(function () { return null; });
	        graph.idxes = data.idxes;
	        graph.nodeIds = data.nodeIds;
	        graph.data = data.data;
	        graph.matrix = data.matrix;
	        graph.nextIdCounter = data.nextIdCounter;
	        return graph;
	    };
	    return EdgeWeightedAdjacencyMatrixGraph;
	}(AdjacencyMatrixGraph));
	exports.EdgeWeightedAdjacencyMatrixGraph = EdgeWeightedAdjacencyMatrixGraph;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var mathjs = __webpack_require__(27);
	var Matrix = (function () {
	    function Matrix() {
	        this._entries = [];
	    }
	    Object.defineProperty(Matrix.prototype, "rows", {
	        get: function () {
	            return this._rows;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Matrix.prototype, "cols", {
	        get: function () {
	            return this._cols;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Matrix.prototype, "raw", {
	        get: function () {
	            return this._entries;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Matrix.prototype.multiply = function (other) {
	        var rows = this.rows;
	        var cols = other.cols;
	        var m = Matrix.make(rows, cols, this.fill, this.formatter);
	        var entries;
	        try {
	            entries = mathjs.multiply(this._entries, other._entries);
	        }
	        catch (err) {
	            entries = [[]];
	        }
	        m._entries = entries;
	        return m;
	    };
	    Matrix.deserialize = function (json, fill, formatter) {
	        var entries = JSON.parse(json);
	        var rows = entries.length;
	        var cols = 0;
	        if (rows > 0) {
	            cols = rows[0].length;
	        }
	        var m = Matrix.make(rows, cols);
	        m._entries = entries;
	        return m;
	    };
	    Matrix.make = function (rows, cols, fill, formatter) {
	        if (rows === void 0) { rows = 0; }
	        if (cols === void 0) { cols = 0; }
	        var m = new Matrix();
	        m._rows = 0;
	        m._cols = 0;
	        m.fill = fill ? fill : function () { return undefined; };
	        m.formatter = formatter ? formatter : function (v) { return JSON.stringify(v); };
	        m.grow(rows, cols, fill);
	        return m;
	    };
	    Matrix.prototype.checkBounds = function (i, j) {
	        var errs = [];
	        if (i > this.rows - 1)
	            errs.push(i + " > " + (this.rows - 1));
	        if (j > this.cols - 1)
	            errs.push(j + " > " + (this.cols - 1));
	        return errs.join(",");
	    };
	    Matrix.prototype.setEntry = function (i, j, val) {
	        var err = this.checkBounds(i, j);
	        if (err)
	            throw new RangeError(err);
	        this._entries[i][j] = val;
	        return this;
	    };
	    Matrix.prototype.getEntry = function (i, j) {
	        if (this.checkBounds(i, j)) {
	            return undefined;
	        }
	        else {
	            return this._entries[i][j];
	        }
	    };
	    Matrix.prototype.forEachEntry = function (fn) {
	        for (var i = 0; i < this.rows; i++) {
	            for (var j = 0; j < this.cols; j++) {
	                fn(this.getEntry(i, j), i, j);
	            }
	        }
	    };
	    Matrix.prototype.serialize = function () {
	        return JSON.stringify(this.raw);
	    };
	    Matrix.prototype.map = function (fn, fill) {
	        var m = new Matrix();
	        m._rows = this.rows;
	        m._cols = this.cols;
	        m.fill = fill;
	        m._entries = this._entries.map(function (row, i) { return row.map(function (entry, j) { return fn(entry, i, j); }); });
	        return m;
	    };
	    Matrix.prototype.flatten = function () {
	        return this._entries.reduce(function (p, n) { return p.concat(n); }, []);
	    };
	    Matrix.prototype.clone = function () {
	        var m = new Matrix();
	        m._rows = this.rows;
	        m._cols = this.cols;
	        m.fill = this.fill ? this.fill : function () { return undefined; };
	        m._entries = this._entries.map(function (row) { return row.slice(); });
	        return m;
	    };
	    Matrix.prototype.grow = function (rows, cols, fill) {
	        if (rows === void 0) { rows = 0; }
	        if (cols === void 0) { cols = 0; }
	        var or = this._entries.length;
	        var oc = or > 0 ? this._entries[0].length : 0;
	        this._rows = this._rows + rows;
	        this._cols = this._cols + cols;
	        var filler;
	        if (typeof fill === "function") {
	            filler = fill;
	        }
	        else if (fill != null) {
	            filler = function () { return fill; };
	        }
	        else {
	            filler = this.fill;
	        }
	        for (var i = or; i < this.rows; i++) {
	            this._entries[i] = new Array(this._cols);
	            for (var j = 0; j < this.cols; j++) {
	                this._entries[i][j] = filler(i, j);
	            }
	        }
	        for (var p = 0; p < or; p++) {
	            var concat = [];
	            for (var q = oc; q < this._cols; q++) {
	                concat.push(filler(p, q));
	            }
	            this._entries[p] = this._entries[p].concat(concat);
	        }
	        return this;
	    };
	    Matrix.prototype.removeRows = function (startIndex, howMany) {
	        if (howMany === void 0) { howMany = 1; }
	        var removed = this._entries.splice(startIndex, howMany);
	        this._rows -= howMany;
	        return removed;
	    };
	    Matrix.prototype.removeColumns = function (startIndex, howMany) {
	        if (howMany === void 0) { howMany = 1; }
	        var removed = this._entries.map(function (row) { return row.splice(startIndex, howMany); });
	        this._cols -= howMany;
	        return removed;
	    };
	    Matrix.prototype.shrink = function (rows, cols) {
	        var _this = this;
	        if (rows === void 0) { rows = 0; }
	        if (cols === void 0) { cols = 0; }
	        this._rows = Math.max(this._rows - rows, 0);
	        this._cols = Math.max(this._cols - cols, 0);
	        this._entries = this._entries.slice(0, this.rows);
	        this._entries = this._entries.map(function (row) { return row.slice(0, _this.cols); });
	        return this;
	    };
	    Matrix.prototype.pretty = function (formatter) {
	        var f = formatter ? formatter : this.formatter;
	        var val = "";
	        for (var _i = 0, _a = this._entries; _i < _a.length; _i++) {
	            var row = _a[_i];
	            val += "[ " + row.map(function (e) { return e != null ? f(e) : ""; }).join(" ") + " ]\n";
	        }
	        return val;
	    };
	    return Matrix;
	}());
	exports.Matrix = Matrix;
	var NumericMatrix = (function (_super) {
	    __extends(NumericMatrix, _super);
	    function NumericMatrix() {
	        return _super.apply(this, arguments) || this;
	    }
	    return NumericMatrix;
	}(Matrix));
	exports.NumericMatrix = NumericMatrix;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var DND = __webpack_require__(38);
	var react_router_1 = __webpack_require__(5);
	var TouchBackend = __webpack_require__(39).default;
	var React = __webpack_require__(2);
	var Sauce = __webpack_require__(7);
	var ReactDOM = __webpack_require__(4);
	var $ = __webpack_require__(17);
	var Form_1 = __webpack_require__(10);
	var Basic_1 = __webpack_require__(29);
	var d3 = __webpack_require__(16);
	var reactstrap_1 = __webpack_require__(40);
	var Algebra_1 = __webpack_require__(41);
	__webpack_require__(42);
	var Clipboard = __webpack_require__(44);
	var GraphBuilder = (function (_super) {
	    __extends(GraphBuilder, _super);
	    function GraphBuilder(props, context) {
	        var _this = _super.call(this, props) || this;
	        _this.setSelection = function (selections) {
	            _this.setState({ nodeSelections: selections });
	        };
	        _this.clearSelection = function () {
	            _this.setState({ nodeSelections: { primarySelectionId: null, secondarySelectionIds: [] } });
	        };
	        _this.signalNodeRect = function (rect) {
	            if (_this.state.nodeRect.width != rect.width || _this.state.nodeRect.height != rect.height) {
	                _this.setState({ nodeRect: rect });
	            }
	        };
	        _this.removeNode = function (id) {
	            var nodeSelections = {
	                primarySelectionId: _this.state.nodeSelections.primarySelectionId !== id ? _this.state.nodeSelections.primarySelectionId : null,
	                secondarySelectionIds: _this.state.nodeSelections.secondarySelectionIds.filter(function (i) { return i !== id; })
	            };
	            _this.setState({ nodeSelections: nodeSelections });
	            _this.props.graph.removeNode(id);
	        };
	        _this.state = {
	            nodeSelections: { primarySelectionId: null, secondarySelectionIds: [] },
	            nodeRect: { width: 50, height: 50 },
	        };
	        return _this;
	    }
	    GraphBuilder.prototype.render = function () {
	        var graph = this.props.graph;
	        return React.createElement("div", { className: "graph-builder" },
	            React.createElement("div", { className: "graph-container" },
	                React.createElement(NodeWell, { graph: graph }),
	                React.createElement(DragPreviewLayer, null),
	                React.createElement(GraphCanvas, { graph: graph, nodeRect: this.state.nodeRect, signalNodeRect: this.signalNodeRect, nodeSelections: this.state.nodeSelections, clearSelection: this.clearSelection, setSelection: this.setSelection, removeNode: this.removeNode, connectDropTarget: function () { return ({}); }, isOver: true }),
	                React.createElement(SvgGraphCanvas, { graph: graph, nodeRect: this.state.nodeRect, signalNodeRect: this.signalNodeRect, nodeSelections: this.state.nodeSelections, clearSelection: this.clearSelection, setSelection: this.setSelection, removeNode: this.removeNode, connectDropTarget: function () { return ({}); }, isOver: true })));
	    };
	    return GraphBuilder;
	}(React.Component));
	GraphBuilder = __decorate([
	    DND.DragDropContext(TouchBackend({ enableMouseEvents: true }))
	], GraphBuilder);
	exports.GraphBuilder = GraphBuilder;
	var DragItemTypes = {
	    NEWNODE: "new-node",
	    MAINNODE: "main-node"
	};
	function nextNodeId(graph) {
	    return "node-" + graph.nextIdNumber();
	}
	var nodeSourceSpec = {
	    beginDrag: function (props) { return ({ label: nextNodeId(props.graph) }); },
	};
	var nodeSourceCollector = function (connect, monitor) {
	    return {
	        connectDragSource: connect.dragSource(),
	        isDragging: monitor.isDragging()
	    };
	};
	var NodeSource = (function (_super) {
	    __extends(NodeSource, _super);
	    function NodeSource(props) {
	        return _super.call(this, props) || this;
	    }
	    NodeSource.prototype.render = function () {
	        var _a = this.props, connectDragSource = _a.connectDragSource, isDragging = _a.isDragging, graph = _a.graph;
	        return connectDragSource(React.createElement("div", null,
	            React.createElement(reactstrap_1.Button, null, nextNodeId(graph))));
	    };
	    return NodeSource;
	}(React.Component));
	NodeSource = __decorate([
	    DND.DragSource(DragItemTypes.NEWNODE, nodeSourceSpec, nodeSourceCollector)
	], NodeSource);
	var NodeWell = (function (_super) {
	    __extends(NodeWell, _super);
	    function NodeWell(props) {
	        var _this = _super.call(this, props) || this;
	        _this.helpid = "help-tooltip";
	        _this.toggle = function () {
	            _this.setState({
	                tooltipOpen: !_this.state.tooltipOpen
	            });
	        };
	        _this.toggleDeepLink = function () {
	            _this.setState({
	                deepLinkTooltipOpen: !_this.state.deepLinkTooltipOpen
	            });
	        };
	        _this.copyDeepLink = function () {
	        };
	        _this.makeDeepLink = function () { return window.location.origin + "/markov/" + _this.props.graph.serialize(); };
	        _this.state = { tooltipOpen: false, deepLinkTooltipOpen: false };
	        return _this;
	    }
	    NodeWell.prototype.render = function () {
	        new Clipboard("#showdeeplink");
	        return React.createElement("div", { className: "node-well" },
	            React.createElement(NodeSource, { isDragging: false, connectDragSource: null, graph: this.props.graph }),
	            React.createElement(react_router_1.Link, { to: this.makeDeepLink() },
	                React.createElement(reactstrap_1.Button, { "data-clipboard-text": this.makeDeepLink(), id: "showdeeplink", className: "ml-1", color: "secondary", onClick: this.copyDeepLink }, "Link")),
	            React.createElement(reactstrap_1.Tooltip, { placement: "bottom", tether: { constraints: [{ to: 'scrollParent', pin: true }] }, isOpen: this.state.deepLinkTooltipOpen, target: "showdeeplink", toggle: this.toggleDeepLink }, "Click to copy a permanent link to the current graph to your clipboard."),
	            React.createElement(reactstrap_1.Button, { className: "mr-1", color: "secondary", id: this.helpid }, "?"),
	            React.createElement(reactstrap_1.Tooltip, { placement: "bottom", tether: { constraints: [{ to: 'scrollParent', pin: true }] }, isOpen: this.state.tooltipOpen, target: this.helpid, toggle: this.toggle },
	                React.createElement("h4", null, "Create New Nodes"),
	                React.createElement("ul", null,
	                    React.createElement("li", null, "Drag the node in the blue area onto the graph."),
	                    React.createElement("li", null, "Or, cmd-click on the graph.")),
	                React.createElement("h4", null, "Create New Edges"),
	                React.createElement("ul", null,
	                    React.createElement("li", null, "Click one node to select the start node."),
	                    React.createElement("li", null, "Select any number of additional nodes, including the start node itself."),
	                    React.createElement("li", null, "Press enter."),
	                    React.createElement("li", null, "Enter the weight for the edges to or from the start node to the other nodes you selected."),
	                    React.createElement("li", null, "As with all number inputs on this website, the weight field accepts arbitrary mathjs expressions, such as \"sin(pi/2)\" or \"1/6\"."),
	                    React.createElement("li", null, "Press enter again to set edges to or from the start node to all selected nodes.")),
	                React.createElement("h4", null, "Remove Nodes"),
	                React.createElement("ul", null,
	                    React.createElement("li", null, "Drag them off the canvas."))));
	    };
	    return NodeWell;
	}(Sauce.Component));
	NodeWell.contextTypes = {
	    router: React.PropTypes.object
	};
	var layerStyles = {
	    position: 'fixed',
	    pointerEvents: 'none',
	    zIndex: 100,
	    left: 0,
	    top: 0,
	    width: '100%',
	    height: '100%',
	    fontSize: '4em'
	};
	function getItemStyles(props) {
	    var initialOffset = props.initialOffset, currentOffset = props.currentOffset;
	    if (!initialOffset || !currentOffset) {
	        return {
	            display: 'none'
	        };
	    }
	    var x = currentOffset.x, y = currentOffset.y;
	    var transform = "translate(" + x + "px, " + y + "px)";
	    return {
	        transform: transform,
	        WebkitTransform: transform
	    };
	}
	function renderItem(type, item) {
	    return React.createElement(reactstrap_1.Button, null, item.label);
	}
	var DragPreviewLayer = (function (_super) {
	    __extends(DragPreviewLayer, _super);
	    function DragPreviewLayer(props) {
	        return _super.call(this, props) || this;
	    }
	    DragPreviewLayer.prototype.render = function () {
	        var _a = this.props, item = _a.item, itemType = _a.itemType, isDragging = _a.isDragging;
	        if (!isDragging) {
	            return null;
	        }
	        var rendered = renderItem(itemType, item);
	        return (React.createElement("div", { style: layerStyles },
	            React.createElement("div", { style: getItemStyles(this.props) }, rendered)));
	    };
	    return DragPreviewLayer;
	}(React.Component));
	DragPreviewLayer = __decorate([
	    DND.DragLayer(function (monitor) { return ({
	        item: monitor.getItem(),
	        itemType: monitor.getItemType(),
	        initialOffset: monitor.getInitialSourceClientOffset(),
	        currentOffset: monitor.getSourceClientOffset(),
	        isDragging: monitor.isDragging()
	    }); })
	], DragPreviewLayer);
	var SelectionMode;
	(function (SelectionMode) {
	    SelectionMode[SelectionMode["PRIMARY"] = 0] = "PRIMARY";
	    SelectionMode[SelectionMode["SECONDARY"] = 1] = "SECONDARY";
	})(SelectionMode || (SelectionMode = {}));
	var graphNodeSpec = {
	    beginDrag: function (props) { return ({ id: props.id, label: props.node.label, nodeRect: props.nodeRect }); },
	    endDrag: function (props, monitor) {
	        if (!monitor.didDrop()) {
	            props.removeNode();
	        }
	    }
	};
	var graphNodeCollector = function (connect, monitor) {
	    return {
	        connectNodeDrag: connect.dragSource(),
	        isDragging: monitor.isDragging()
	    };
	};
	var CanvasNodeMain = (function (_super) {
	    __extends(CanvasNodeMain, _super);
	    function CanvasNodeMain(props) {
	        var _this = _super.call(this, props) || this;
	        _this.signal = function (dom) {
	            return dom && _this.props.signalNodeRect(dom.getBoundingClientRect());
	        };
	        _this.state = { nodeRect: null };
	        return _this;
	    }
	    CanvasNodeMain.prototype.render = function () {
	        var _a = this.props, id = _a.id, node = _a.node, connectNodeDrag = _a.connectNodeDrag, selectionMode = _a.selectionMode;
	        var innerBorder = selectionMode.includes(SelectionMode.PRIMARY) ? React.createElement("div", { className: "node-selection-primary" }) : null;
	        var outerBorder = selectionMode.includes(SelectionMode.SECONDARY) ? React.createElement("div", { className: "node-selection-secondary" }) : null;
	        return React.createElement("div", { id: id, ref: this.signal },
	            innerBorder,
	            outerBorder,
	            React.createElement(reactstrap_1.Button, null, node.label));
	    };
	    return CanvasNodeMain;
	}(React.Component));
	var _CanvasNode = (function (_super) {
	    __extends(_CanvasNode, _super);
	    function _CanvasNode(props) {
	        var _this = _super.call(this, props) || this;
	        _this.toggle = function () { return _this.setState(function (prevState) { return ({ promptWeight: !prevState.promptWeight }); }); };
	        _this.state = { promptWeight: false };
	        return _this;
	    }
	    _CanvasNode.prototype.render = function () {
	        var _a = this.props, id = _a.id, connectNodeDrag = _a.connectNodeDrag, node = _a.node, selectionMode = _a.selectionMode, clickNode = _a.clickNode, nodeRect = _a.nodeRect, removeNode = _a.removeNode;
	        var classes = "canvas-node";
	        var g = connectNodeDrag(React.createElement("div", { className: classes, onClick: function (ev) {
	                clickNode(id);
	            }, style: { top: node.position.y, left: node.position.x } },
	            React.createElement(CanvasNodeMain, { id: id, nodeRect: nodeRect, signalNodeRect: this.props.signalNodeRect, node: node, clickNode: clickNode, selectionMode: selectionMode, connectNodeDrag: connectNodeDrag, removeNode: removeNode })));
	        return g;
	    };
	    return _CanvasNode;
	}(React.Component));
	var CanvasNode = DND.DragSource(DragItemTypes.MAINNODE, graphNodeSpec, graphNodeCollector)(_CanvasNode);
	var EdgeWeightForm = (function (_super) {
	    __extends(EdgeWeightForm, _super);
	    function EdgeWeightForm(props) {
	        var _this = _super.call(this, props) || this;
	        _this.validateWeight = new Basic_1.Real().make();
	        _this.validateLabel = new Basic_1.Label().make();
	        _this.state = {
	            tofrom: "to",
	        };
	        return _this;
	    }
	    EdgeWeightForm.prototype.componentDidMount = function () {
	        var el = ReactDOM.findDOMNode(this);
	        $(el).children(".edge-weight-value").select();
	    };
	    EdgeWeightForm.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, graph = _a.graph, primaryId = _a.primaryId, secondaryIds = _a.secondaryIds;
	        var tofrom = this.state.tofrom;
	        var nodeId = this.props.primaryId;
	        var displayWeight;
	        var weights = secondaryIds
	            .map(function (s) { return tofrom === "to" ? graph.getEdge(primaryId, s) : graph.getEdge(s, primaryId); });
	        if (weights.length > 0) {
	            if (weights.every(function (w) { return w.weight === weights[0].weight; })) {
	                displayWeight = weights[0].weightParseResult.raw;
	            }
	            else {
	                displayWeight = "multiple values";
	            }
	        }
	        return React.createElement("div", { className: "edge-weight" },
	            React.createElement("div", { onChange: function (ev) { return _this.setState({ tofrom: ev.target.value }); } },
	                React.createElement("input", { type: "radio", value: "to", name: "tofrom", defaultChecked: this.state.tofrom === "to" }),
	                "To",
	                React.createElement("input", { type: "radio", value: "from", name: "tofrom", defaultChecked: this.state.tofrom === "from" }),
	                "From"),
	            React.createElement("label", { className: "edge-weight-value-label" }, "Weight"),
	            React.createElement(Form_1.NumberInput, { className: "edge-weight-value", autoFocus: true, value: displayWeight, processor: this.validateWeight, flush: function (val) {
	                    if (val.valid) {
	                        _this.props.setWeight(_this.props.primaryId, _this.props.secondaryIds, val, _this.state.tofrom);
	                    }
	                } }),
	            React.createElement(Form_1.StringTextInput, { className: "node-label", value: graph.getNodeById(primaryId).label, processor: this.validateLabel, flush: function (val) {
	                    if (val.valid) {
	                        graph.setNode(nodeId, { label: val.value });
	                    }
	                } }));
	    };
	    return EdgeWeightForm;
	}(Sauce.Component));
	var canvasDropTargetSpecification = {
	    drop: function (props, monitor, component) {
	        var pos = monitor.getSourceClientOffset();
	        var offset = ReactDOM.findDOMNode(component).getBoundingClientRect();
	        var relpos = {
	            x: pos.x - offset.left,
	            y: pos.y - offset.top
	        };
	        var graph = props.graph;
	        if (monitor.getItemType() === DragItemTypes.MAINNODE) {
	            var node = monitor.getItem();
	            graph.setNode(node.id, { position: relpos });
	        }
	        else if (monitor.getItemType() === DragItemTypes.NEWNODE) {
	            var nodeid = nextNodeId(graph);
	            graph.addNode(nodeid, { position: relpos, label: nodeid });
	        }
	    },
	};
	function canvasDropTargetCollectingFunction(connect, monitor) {
	    return {
	        connectDropTarget: connect.dropTarget(),
	        isOver: monitor.isOver(),
	    };
	}
	var GraphCanvas = (function (_super) {
	    __extends(GraphCanvas, _super);
	    function GraphCanvas(props) {
	        var _this = _super.call(this, props) || this;
	        _this.setWeight = function (a, b, weight, tofrom) {
	            var graph = _this.props.graph;
	            if (weight.valid) {
	                if (tofrom === "to") {
	                    graph.setEdge(a, b, { weight: weight.value, weightParseResult: weight });
	                }
	                else {
	                    graph.setEdge(b, a, { weight: weight.value, weightParseResult: weight });
	                }
	            }
	        };
	        _this.clickNode = function (id) {
	            var nodeSelections = _this.props.nodeSelections;
	            if (!nodeSelections.primarySelectionId) {
	                nodeSelections.primarySelectionId = id;
	            }
	            else {
	                if (nodeSelections.primarySelectionId === id) {
	                    nodeSelections.secondarySelectionIds.push(id);
	                }
	                else {
	                    if (nodeSelections.secondarySelectionIds.includes(id)) {
	                        nodeSelections.secondarySelectionIds = nodeSelections.secondarySelectionIds.filter(function (i) { return i !== id; });
	                    }
	                    else {
	                        nodeSelections.secondarySelectionIds.push(id);
	                    }
	                }
	            }
	            _this.props.setSelection(nodeSelections);
	        };
	        _this.clickGraph = function (ev) {
	            var graph = _this.props.graph;
	            if (ev.target == ev.currentTarget && ev.metaKey) {
	                var pos = { x: ev.pageX, y: ev.pageY };
	                var centerNodeOffset = _this.props.nodeRect;
	                var offset = ReactDOM.findDOMNode(_this).getBoundingClientRect();
	                var relpos = {
	                    x: pos.x - Math.floor(centerNodeOffset.width / 2) - offset.left,
	                    y: pos.y - Math.floor(centerNodeOffset.height / 2) - offset.top
	                };
	                var id = nextNodeId(graph);
	                graph.addNode(id, { position: relpos, label: id });
	            }
	        };
	        _this.clearSelection = function () {
	            _this.setState({ promptingWeight: false });
	            _this.props.clearSelection();
	        };
	        _this.state = { promptingWeight: false };
	        return _this;
	    }
	    GraphCanvas.prototype.onEnter = function () {
	        var _a = this.props.nodeSelections, primarySelectionId = _a.primarySelectionId, secondarySelectionIds = _a.secondarySelectionIds;
	        if (this.state.promptingWeight) {
	            this.clearSelection();
	        }
	        else if (primarySelectionId && secondarySelectionIds && secondarySelectionIds.length > 0) {
	            this.setState({ promptingWeight: true });
	        }
	    };
	    GraphCanvas.prototype.componentDidMount = function () {
	        var _this = this;
	        var _a = this.props.nodeSelections, primarySelectionId = _a.primarySelectionId, secondarySelectionIds = _a.secondarySelectionIds;
	        window.addEventListener("keydown", function (ev) {
	            if (ev.keyCode === 27) {
	                _this.clearSelection();
	            }
	            else if (ev.keyCode === 13) {
	                _this.onEnter();
	            }
	        });
	    };
	    GraphCanvas.prototype.getSelectionMode = function (id, _a) {
	        var primarySelectionId = _a.primarySelectionId, secondarySelectionIds = _a.secondarySelectionIds;
	        var selectionMode = [];
	        if (primarySelectionId === id) {
	            selectionMode.push(SelectionMode.PRIMARY);
	        }
	        if (secondarySelectionIds.includes(id)) {
	            selectionMode.push(SelectionMode.SECONDARY);
	        }
	        return selectionMode;
	    };
	    GraphCanvas.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, connectDropTarget = _a.connectDropTarget, graph = _a.graph, removeNode = _a.removeNode;
	        var _b = this.props.nodeSelections, primarySelectionId = _b.primarySelectionId, secondarySelectionIds = _b.secondarySelectionIds;
	        var promptingWeight = this.state.promptingWeight;
	        var nodeEls = graph.getNodeIds().map(function (k) {
	            var node = graph.getNodeById(k);
	            return React.createElement(CanvasNode, { key: k, id: k, graph: graph, clickNode: _this.clickNode, signalNodeRect: _this.props.signalNodeRect, selectionMode: _this.getSelectionMode(k, _this.props.nodeSelections), removeNode: function () { return removeNode(k); }, node: graph.getNodeById(k), connectNodeDrag: null });
	        });
	        var edgeWeight = promptingWeight && primarySelectionId && React.createElement(reactstrap_1.Popover, { placement: "top", target: primarySelectionId, isOpen: true },
	            React.createElement(reactstrap_1.PopoverContent, null,
	                React.createElement(EdgeWeightForm, { key: 1, graph: graph, setWeight: this.setWeight, primaryId: primarySelectionId, secondaryIds: secondarySelectionIds, clearSelection: this.clearSelection })));
	        var hiddenNodeProps = {
	            position: { x: 0, y: 0 },
	            label: "node-0"
	        };
	        var hiddenMeasuringNode = React.createElement("div", { style: { visibility: "hidden" } },
	            React.createElement(CanvasNode, { graph: graph, clickNode: function () { return ({}); }, signalNodeRect: this.props.signalNodeRect, selectionMode: [], connectNodeDrag: null, node: hiddenNodeProps }));
	        return connectDropTarget(React.createElement("div", { className: "graph-canvas", onClick: this.clickGraph },
	            hiddenMeasuringNode,
	            edgeWeight,
	            nodeEls));
	    };
	    return GraphCanvas;
	}(React.Component));
	GraphCanvas = __decorate([
	    DND.DropTarget([DragItemTypes.NEWNODE, DragItemTypes.MAINNODE], canvasDropTargetSpecification, canvasDropTargetCollectingFunction)
	], GraphCanvas);
	var Orientation;
	(function (Orientation) {
	    Orientation[Orientation["top"] = 0] = "top";
	    Orientation[Orientation["right"] = 1] = "right";
	    Orientation[Orientation["bottom"] = 2] = "bottom";
	    Orientation[Orientation["left"] = 3] = "left";
	})(Orientation || (Orientation = {}));
	;
	var SvgGraphCanvas = (function (_super) {
	    __extends(SvgGraphCanvas, _super);
	    function SvgGraphCanvas(props) {
	        return _super.call(this, props) || this;
	    }
	    SvgGraphCanvas.prototype.render = function () {
	        var boxBottomRight = new Algebra_1.Vec2(this.props.nodeRect.width, this.props.nodeRect.height);
	        var midpoint = boxBottomRight.scalar(1 / 2);
	        var markerWidth = 6;
	        var makeD = d3.line()
	            .x(function (_a) {
	            var x = _a.x;
	            return x;
	        })
	            .y(function (_a) {
	            var y = _a.y;
	            return y;
	        });
	        var graph = this.props.graph;
	        var _a = this.props.nodeSelections, primarySelectionId = _a.primarySelectionId, secondarySelectionIds = _a.secondarySelectionIds;
	        var linkEls = graph.getNonNullEdges().map(function (e) {
	            if (e.val.weight === 0)
	                return;
	            var fromNode = graph.getNodeById(e.from);
	            var toNode = graph.getNodeById(e.to);
	            var from = new Algebra_1.Vec2(fromNode.position);
	            var to = new Algebra_1.Vec2(toNode.position);
	            var p;
	            var t = to.plus(midpoint);
	            if (to.equal(from)) {
	                var c1 = t.plus(new Algebra_1.Vec2(-75, -100));
	                var c2 = t.plus(new Algebra_1.Vec2(-75, 100));
	                return React.createElement("path", { d: "M" + t.minus(new Algebra_1.Vec2(0.25 * midpoint.x, midpoint.y)).d() +
	                        "C" + c1.d() + c2.d() + t.plus(new Algebra_1.Vec2(-0.25 * midpoint.x, midpoint.y + 8)).d(), key: e.from + "_" + e.to, markerEnd: "url(#Arrowhead)", fill: "none", stroke: "steelblue", strokeWidth: "2" });
	            }
	            var toBox = new Algebra_1.AxisAlignedBox2(to, to.plus(boxBottomRight));
	            var f = from.plus(midpoint);
	            var intersect = t.boxIntersectionPoint(toBox, f);
	            var translatedIntersect = intersect.minus(f);
	            var edgeTerminator = translatedIntersect.scaleTo(translatedIntersect.norm() - 10).plus(f);
	            try {
	                p = React.createElement("path", { d: makeD([f, edgeTerminator]), key: e.from + "_" + e.to, markerEnd: "url(#Arrowhead)", fill: "none", stroke: "steelblue", strokeWidth: "2" });
	            }
	            finally {
	                return p;
	            }
	        });
	        var arrow = React.createElement("marker", { id: "Arrowhead", markerWidth: markerWidth, markerHeight: "6", orient: "auto", refX: "1", refY: "5", viewBox: "0 0 10 10" }, React.createElement("path", { d: "M 0 0 L 10 5 L 0 10 z" }));
	        var canvas = React.createElement("svg", { key: 0, className: "graph-canvas" },
	            React.createElement("defs", null,
	                arrow,
	                "  "),
	            linkEls);
	        return canvas;
	    };
	    return SvgGraphCanvas;
	}(React.Component));


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(727);

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(948);

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(949);

/***/ },
/* 41 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	function zip(a, b) {
	    var ret = [];
	    for (var i = 0; i < a.length; i++) {
	        if (i >= b.length) {
	            break;
	        }
	        ret.push([a[i], b[i]]);
	    }
	    return ret;
	}
	var Vector = (function () {
	    function Vector() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (typeof args[0] === 'number') {
	            this.els = args;
	        }
	        else {
	            this.els = args[0];
	        }
	    }
	    Vector.prototype.equal = function (b) {
	        return zip(this.els, b.els).every(function (z) { return z[0] === z[1]; });
	    };
	    Vector.prototype.norm = function () {
	        return this.lnorm(2);
	    };
	    Vector.prototype.normalize = function () {
	        return this.scalar(1 / this.norm());
	    };
	    Vector.prototype.lnorm = function (n) {
	        var val = this.els.reduce(function (p, c) { return p + Math.pow(c, n); }, 0);
	        return Math.pow(val, 1 / n);
	    };
	    Vector.prototype.dot = function (b) {
	        if (b.els.length !== this.els.length) {
	            return undefined;
	        }
	        return zip(this.els, b.els).map(function (p) { return p[0] * p[1]; }).reduce(function (prev, cur) { return prev + cur; }, 0);
	    };
	    Vector.prototype.angle = function (b) {
	        if (this.els.length !== b.els.length) {
	            return undefined;
	        }
	        if (this.els.length == 2) {
	            return Math.atan2(b.els[1], b.els[0]) - Math.atan2(this.els[1], this.els[0]);
	        }
	        else {
	            Math.acos(this.dot(b) / (this.norm() * b.norm()));
	        }
	    };
	    Vector.prototype.plus = function (b) {
	        if (this.els.length !== b.els.length) {
	            return undefined;
	        }
	        var z = zip(this.els, b.els);
	        var map = z.map(function (p) { return p[0] + p[1]; });
	        return new this.constructor(map);
	    };
	    Vector.prototype.minus = function (b) {
	        if (this.els.length !== b.els.length) {
	            return undefined;
	        }
	        var z = zip(this.els, b.els);
	        var map = z.map(function (p) { return p[0] - p[1]; });
	        return new this.constructor(map);
	    };
	    Vector.prototype.scalar = function (s) {
	        return new this.constructor(this.els.map(function (v) { return s * v; }));
	    };
	    Vector.prototype.scaleTo = function (s) {
	        var l = this.norm();
	        return this.scalar(s / l);
	    };
	    return Vector;
	}());
	exports.Vector = Vector;
	var AxisAlignedBox2 = (function () {
	    function AxisAlignedBox2(topLeft, bottomRight) {
	        this.topLeft = topLeft;
	        this.bottomRight = bottomRight;
	    }
	    return AxisAlignedBox2;
	}());
	exports.AxisAlignedBox2 = AxisAlignedBox2;
	var Vec2 = (function (_super) {
	    __extends(Vec2, _super);
	    function Vec2() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var _this;
	        var x;
	        var y;
	        if (args[0] instanceof Array) {
	            x = args[0][0];
	            y = args[0][1];
	        }
	        else if (typeof args[0] === 'number') {
	            x = args[0];
	            y = args[1];
	        }
	        else {
	            x = args[0].x;
	            y = args[0].y;
	        }
	        _this = _super.call(this, x, y) || this;
	        _this.x = x;
	        _this.y = y;
	        return _this;
	    }
	    Vec2.prototype.angleXAxisDeg = function () {
	        return this.angleXAxis() * 180 / Math.PI;
	    };
	    Vec2.prototype.angleXAxis = function () {
	        return this.angle(new Vec2(1, 0));
	    };
	    Vec2.prototype.d = function () {
	        return (this.x + "," + this.y + " ");
	    };
	    Vec2.prototype.boxIntersectionPoint = function (box, origin) {
	        if (origin === void 0) { origin = new Vec2(0, 0); }
	        var tl = box.topLeft.minus(origin);
	        var br = box.bottomRight.minus(origin);
	        var d = this.minus(origin).normalize();
	        var t0x = (tl.x) / d.x;
	        var t1x = (br.x) / d.x;
	        var t0y = (tl.y) / d.y;
	        var t1y = (br.y) / d.y;
	        var txmin = Math.min(t0x, t1x);
	        var txmax = Math.max(t0x, t1x);
	        var tymin = Math.min(t0y, t1y);
	        var tymax = Math.max(t0y, t1y);
	        var miss = (tymax < txmin || txmax < tymin);
	        if (miss)
	            return undefined;
	        var t = txmin > tymin ? txmin : tymin;
	        return new Vec2(d.scalar(t)).plus(origin);
	    };
	    return Vec2;
	}(Vector));
	exports.Vec2 = Vec2;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(43);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./GraphBuilder.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./GraphBuilder.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, "#help-tooltip{position:absolute;right:0}.tooltip-inner{max-width:450px;text-align:left}.graph-container{width:100%;display:flex;justify-content:center;flex-direction:column;position:relative;height:calc(4em + 600px);align-items:center}.noselect{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.markov-container{flex-direction:column;width:100%;line-height:1}.markov-container,.node-well{display:flex;justify-content:center;align-items:center}.node-well{width:600px;border:1px solid #000;background-color:#4682b4;height:4em;position:absolute;top:0}.node-well .node-source{background-color:#fff}.node-selection-primary{width:calc(100% + 2px);height:calc(100% + 2px);top:-1px;left:-1px;border:1px solid darkred;position:absolute}.node-selection-secondary{width:calc(100% + 6px);height:calc(100% + 6px);top:-3px;left:-3px;border:1px solid #006400;position:absolute}div.graph-canvas{z-index:50}.graph-canvas{width:600px;height:600px;border:1px solid #000;border-top:none;box-sizing:border-box;position:absolute;top:4em}.graph-canvas .canvas-node{background:#fff;position:absolute;display:flex;justify-content:center;flex-direction:row}.graph-canvas .canvas-node.primary-selection{border:1px solid red;border-color:red}.graph-canvas .canvas-node.secondary-selection{border:1px solid #32cd32;border-color:#32cd32}", ""]);
	
	// exports


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(699);

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var React = __webpack_require__(2);
	var Sauce = __webpack_require__(7);
	var ReactDOM = __webpack_require__(4);
	var $ = __webpack_require__(17);
	var _ = __webpack_require__(11);
	var Util = __webpack_require__(19);
	var update = __webpack_require__(46);
	var d3 = __webpack_require__(16);
	var Basic_1 = __webpack_require__(29);
	var DisplayNumber_1 = __webpack_require__(48);
	var ReactDOMServer = __webpack_require__(51);
	__webpack_require__(69);
	var MatrixViewer = (function (_super) {
	    __extends(MatrixViewer, _super);
	    function MatrixViewer(props) {
	        var _this = _super.call(this, props) || this;
	        _this.uniqueId = Util.makeDomId(_.uniqueId("graph-viewer-"));
	        _this.containerId = _this.uniqueId + "-popover-container";
	        _this.weightValidator = new Basic_1.Real().make();
	        _this.openPopupId = "";
	        _this.handler = function (el) { return _this.setState({ containerWidth: $(el).innerWidth() }); };
	        _this.margin = {
	            top: 80,
	            right: 0,
	            bottom: 10,
	            left: Math.SQRT2 * 80
	        };
	        _this.state = { containerWidth: undefined, openPopupId: "", entryDisplayMode: {} };
	        return _this;
	    }
	    MatrixViewer.prototype.componentDidUpdate = function () {
	        this.update(ReactDOM.findDOMNode(this), this.props, this.state);
	    };
	    MatrixViewer.prototype.makeCellsForRow = function (props, state, self, x) {
	        return function (row, i) {
	            var entryProps = props.entryProps;
	            var cells = d3.select(this).selectAll(".cell")
	                .data(row.filter(function (cell) { return cell.value; }), function (d) {
	                var e = d;
	                if (e.i !== undefined) {
	                    return e.i + "_" + e.j;
	                }
	                return "";
	            });
	            cells.enter().append("g")
	                .attr("class", "cell")
	                .call(function (g) {
	                g.append("g")
	                    .attr("text-anchor", "middle")
	                    .attr("alignment-baseline", "middle");
	            })
	                .merge(cells)
	                .attr("width", x.bandwidth())
	                .attr("height", x.bandwidth())
	                .attr("transform", function (d) { return "translate(" + x(d.j) + ", 0 )"; })
	                .call(function (g) {
	                g.select("g")
	                    .html(function (d) {
	                    var entryId = d.i + "-" + d.j;
	                    var entryDisplayId = self.uniqueId + "-" + entryId;
	                    var display = React.createElement(DisplayNumber_1.DisplayNumberSvgText, { toggle: function () { return self.setState({ openPopupId: entryId }); }, maxWidth: x.bandwidth(), num: entryProps(d.value).weight, displayRaw: state.entryDisplayMode[entryId] !== "numeric", id: entryDisplayId, minPrecision: 3 });
	                    return ReactDOMServer.renderToStaticMarkup(display);
	                });
	                g.select("text")
	                    .attr("x", x.bandwidth() / 2)
	                    .attr("y", x.bandwidth() / 2)
	                    .attr("class", "tappable")
	                    .attr("id", function (d) { return self.uniqueId + "-" + d.i + "-" + d.j; })
	                    .on("click", function (d) { return self.setState({ openPopupId: d.i + "-" + d.j }); });
	            });
	        };
	    };
	    MatrixViewer.prototype.displayEntries = function (entries) {
	        return entries.map(function (row, i) { return row.map(function (cell, j) { return ({ value: cell, i: i, j: j }); }); });
	    };
	    MatrixViewer.prototype.update = function (el, newProps, state) {
	        var margin = this.margin;
	        var entryProps = newProps.entryProps, entries = newProps.entries, outerWidth = newProps.outerWidth, outerHeight = newProps.outerHeight, columnLabels = newProps.columnLabels, rowLabels = newProps.rowLabels;
	        if (!_.isFinite(outerHeight))
	            outerHeight = outerWidth;
	        var height = outerHeight - margin.top - margin.bottom;
	        var width = outerWidth - margin.left - margin.right;
	        var matrix = this.displayEntries(entries);
	        var rowLen = entries.length;
	        var colLen = rowLen > 0 ? entries[0].length : 0;
	        var x = d3.scaleBand()
	            .rangeRound([0, width])
	            .domain(d3.range(colLen))
	            .align(0);
	        var y = d3.scaleBand()
	            .rangeRound([0, height])
	            .domain(d3.range(rowLen))
	            .align(0);
	        var row = d3.select("#" + this.uniqueId).selectAll(".row").data(matrix);
	        row.exit().remove();
	        var rowG = row.enter().append("g")
	            .attr("class", "row");
	        rowG.append("line")
	            .attr("x2", width);
	        rowG.merge(row)
	            .attr("transform", function (d, i) { return "translate(0," + y(i) + ")"; })
	            .each(this.makeCellsForRow(newProps, state, this, x));
	        var column = d3.select("#" + this.uniqueId).selectAll(".column").data(matrix);
	        column.exit().remove();
	        var columnG = column.enter().append("g")
	            .attr('class', "column");
	        columnG.append("line")
	            .attr("x1", -width);
	        columnG.merge(column)
	            .attr("transform", function (d, i) { return "translate(" + x(i) + ") rotate(-90)"; });
	        if (rowLabels) {
	            var rowLabel = d3.select("#" + this.uniqueId).selectAll(".row-label").data(rowLabels, function (l) { return l.id; });
	            rowLabel.enter()
	                .append("text")
	                .attr('class', 'row-label')
	                .attr("text-anchor", "end")
	                .attr("alignment-baseline", "middle")
	                .merge(rowLabel)
	                .attr("transform", function (d, i) { return "translate(0, " + (x(i) + x.bandwidth() / 2) + ")"; })
	                .text(function (d) { return d.label; });
	            rowLabel.exit().remove();
	        }
	        if (columnLabels) {
	            var columnLabel = d3.select("#" + this.uniqueId).selectAll(".column-label").data(columnLabels, function (n) { return n.id; });
	            columnLabel.enter()
	                .append("g")
	                .attr("class", "column-label")
	                .call(function (g) {
	                g.append("line")
	                    .attr("class", "label-underline")
	                    .attr("stroke-width", 1);
	                g.append("text")
	                    .attr("text-anchor", "start")
	                    .attr("alignment-baseline", "middle");
	            })
	                .merge(columnLabel)
	                .call(function (g) {
	                g.select(".label-underline")
	                    .attr("x2", Math.SQRT2 * margin.top)
	                    .attr("transform", function (d, i) {
	                    return "translate(" + (x(i) + 2) + ", 0)rotate(-45)";
	                });
	                g.select("text")
	                    .attr("transform", function (d, i) { return "translate(" + x(i) + ", -5) rotate(-45)"; })
	                    .text(function (d) { return d.label; });
	            });
	            columnLabel.exit().remove();
	        }
	    };
	    MatrixViewer.prototype.render = function () {
	        var _this = this;
	        var _a = this, margin = _a.margin, uniqueId = _a.uniqueId;
	        var _b = this.props, entryProps = _b.entryProps, entries = _b.entries, outerWidth = _b.outerWidth, outerHeight = _b.outerHeight, columnLabels = _b.columnLabels, rowLabels = _b.rowLabels;
	        if (!_.isFinite(outerHeight))
	            outerHeight = outerWidth;
	        var height = outerHeight - margin.top - margin.bottom;
	        var width = outerWidth - margin.left - margin.right;
	        var matrix = this.displayEntries(entries);
	        var rowLen = entries.length;
	        var colLen = rowLen > 0 ? entries[0].length : 0;
	        var x = d3.scaleBand()
	            .rangeRound([0, width])
	            .domain(d3.range(colLen))
	            .align(0);
	        var y = d3.scaleBand()
	            .rangeRound([0, height])
	            .domain(d3.range(rowLen))
	            .align(0);
	        var realX = x.bandwidth() * colLen;
	        var realY = y.bandwidth() * rowLen;
	        var popovers = matrix.map(function (row) { return row.map(function (e) {
	            if (e.value) {
	                var entryId_1 = e.i + "-" + e.j;
	                return React.createElement(DisplayNumber_1.DisplayNumberPopoverContent, { toggle: function () { return _this.state.openPopupId ? _this.setState({ openPopupId: "" }) : _this.setState({ openPopupId: entryId_1 }); }, maxWidth: x.bandwidth(), num: entryProps(e.value).weight, displayRaw: _this.state.entryDisplayMode[entryId_1] !== "numeric", toggleRaw: function () {
	                        var displaymode = _this.state.entryDisplayMode[entryId_1];
	                        var other = displaymode === "numeric" ? "expression" : "numeric";
	                        var mergePart = {};
	                        mergePart[entryId_1] = other;
	                        var newState = update(_this.state, { entryDisplayMode: { $merge: mergePart } });
	                        _this.setState(newState);
	                    }, id: _this.uniqueId + "-" + entryId_1, open: _this.state.openPopupId === "" + entryId_1, minPrecision: 3 });
	            }
	        }); });
	        return React.createElement("div", { className: "graph-matrix-viewer" },
	            React.createElement("svg", { width: outerWidth, height: outerHeight },
	                React.createElement("rect", { width: outerWidth, height: outerHeight, stroke: "black", fill: "none" }),
	                React.createElement("g", { id: this.uniqueId, transform: "translate(" + (outerWidth - realX) + ", " + margin.top + ")" },
	                    React.createElement("rect", { className: "background", width: realX, height: realY }))),
	            popovers);
	    };
	    return MatrixViewer;
	}(Sauce.Component));
	exports.MatrixViewer = MatrixViewer;


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(47);
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var splice = Array.prototype.splice;
	
	var assign = Object.assign || function assign(target, source) {
	  var keys = getAllKeys(source);
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (hasOwnProperty.call(source, key)) {
	      target[key] = source[key];
	    }
	  }
	  return target;
	}
	
	var getAllKeys = typeof Object.getOwnPropertySymbols === 'function' ?
	  function(obj) { return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj)) } :
	  function(obj) { return Object.keys(obj) }
	;
	
	function copy(object) {
	  if (object instanceof Array) {
	    return object.slice();
	  } else if (object && typeof object === 'object') {
	    return assign(new object.constructor(), object);
	  } else {
	    return object;
	  }
	}
	
	
	function newContext() {
	  var commands = assign({}, defaultCommands);
	  update.extend = function(directive, fn) {
	    commands[directive] = fn;
	  }
	
	  return update;
	
	  function update(object, spec) {
	    invariant(
	      !Array.isArray(spec),
	      'update(): You provided an invalid spec to update(). The spec may ' +
	      'not contain an array except as the value of $set, $push, $unshift, ' +
	      '$splice or any custom command allowing an array value.'
	    );
	
	    invariant(
	      typeof spec === 'object' && spec !== null,
	      'update(): You provided an invalid spec to update(). The spec and ' +
	      'every included key path must be plain objects containing one of the ' +
	      'following commands: %s.',
	      Object.keys(commands).join(', ')
	    );
	
	    var nextObject = object;
	    var specKeys = getAllKeys(spec)
	    var index, key;
	    for (index = 0; index < specKeys.length; index++) {
	      var key = specKeys[index];
	      if (hasOwnProperty.call(commands, key)) {
	        nextObject = commands[key](spec[key], nextObject, spec, object);
	      } else {
	        var nextValueForKey = update(object[key], spec[key]);
	        if (nextValueForKey !== nextObject[key]) {
	          if (nextObject === object) {
	            nextObject = copy(object);
	          }
	          nextObject[key] = nextValueForKey;
	        }
	      }
	    }
	    return nextObject;
	  }
	
	}
	
	var defaultCommands = {
	  $push: function(value, original, spec) {
	    invariantPushAndUnshift(original, spec, '$push');
	    return original.concat(value);
	  },
	  $unshift: function(value, original, spec) {
	    invariantPushAndUnshift(original, spec, '$unshift');
	    return value.concat(original);
	  },
	  $splice: function(value, nextObject, spec, object) {
	    var originalValue = nextObject === object ? copy(object) : nextObject;
	    invariantSplices(originalValue, spec);
	    value.forEach(function(args) {
	      invariantSplice(args);
	      splice.apply(originalValue, args);
	    });
	    return originalValue;
	  },
	  $set: function(value, original, spec) {
	    invariantSet(spec);
	    return value;
	  },
	  $merge: function(value, nextObject, spec, object) {
	    var originalValue = nextObject === object ? copy(object) : nextObject;
	    invariantMerge(originalValue, value);
	    getAllKeys(value).forEach(function(key) {
	      originalValue[key] = value[key];
	    });
	    return originalValue;
	  },
	  $apply: function(value, original) {
	    invariantApply(value);
	    return value(original);
	  }
	};
	
	
	
	module.exports = newContext();
	module.exports.newContext = newContext;
	
	
	// invariants
	
	function invariantPushAndUnshift(value, spec, command) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected target of %s to be an array; got %s.',
	    command,
	    value
	  );
	  var specValue = spec[command];
	  invariant(
	    Array.isArray(specValue),
	    'update(): expected spec of %s to be an array; got %s. ' +
	    'Did you forget to wrap your parameter in an array?',
	    command,
	    specValue
	  );
	}
	
	function invariantSplices(value, spec) {
	  invariant(
	    Array.isArray(value),
	    'Expected $splice target to be an array; got %s',
	    value
	  );
	  invariantSplice(spec['$splice']);
	}
	
	function invariantSplice(value) {
	  invariant(
	    Array.isArray(value),
	    'update(): expected spec of $splice to be an array of arrays; got %s. ' +
	    'Did you forget to wrap your parameters in an array?',
	    value
	  );
	}
	
	function invariantApply(fn) {
	  invariant(
	    typeof fn === 'function',
	    'update(): expected spec of $apply to be a function; got %s.',
	    fn
	  );
	}
	
	function invariantSet(spec) {
	  invariant(
	    Object.keys(spec).length === 1,
	    'Cannot have more than one key in an object with $set'
	  );
	}
	
	function invariantMerge(target, specValue) {
	  invariant(
	    specValue && typeof specValue === 'object',
	    'update(): $merge expects a spec of type \'object\'; got %s',
	    specValue
	  );
	  invariant(
	    target && typeof target === 'object',
	    'update(): $merge expects a target of type \'object\'; got %s',
	    target
	  );
	}


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(750);

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var Sauce = __webpack_require__(7);
	var React = __webpack_require__(2);
	var Util_1 = __webpack_require__(19);
	var reactstrap_1 = __webpack_require__(40);
	var Util = __webpack_require__(19);
	var _ = __webpack_require__(11);
	__webpack_require__(49);
	var defaultFont = "16px Anonymous Pro";
	function getRenderText(num, maxWidth, minPrecision, maxPrecision, displayRaw, document, font) {
	    var renderText;
	    font = font || defaultFont;
	    if (num == null)
	        return;
	    if (maxWidth) {
	        if (displayRaw) {
	            var rawLength = Util_1.getTextWidth(num.raw, font, document);
	            if (rawLength <= maxWidth) {
	                renderText = num.raw;
	            }
	        }
	        if (!renderText) {
	            var formattedLength = Util_1.getTextWidth(num.formatted, font, document);
	            if (formattedLength <= maxWidth) {
	                renderText = num.formatted;
	            }
	        }
	        if (!renderText) {
	            var maxPrecisionNum = num.value.toPrecision(maxPrecision);
	            var parsedLength = Util_1.getTextWidth(maxPrecisionNum, font, document);
	            if (parsedLength <= maxWidth) {
	                renderText = maxPrecisionNum;
	            }
	            else if (minPrecision != null) {
	                var curPrecision = minPrecision || 1;
	                var prev = void 0;
	                do {
	                    var minPrecisionNum = num.value.toPrecision(curPrecision);
	                    if (minPrecisionNum === prev) {
	                        break;
	                    }
	                    parsedLength = Util_1.getTextWidth(minPrecisionNum, font, document);
	                    if (parsedLength <= maxWidth) {
	                        renderText = minPrecisionNum;
	                    }
	                    curPrecision++;
	                    prev = minPrecisionNum;
	                } while (parsedLength < maxWidth);
	            }
	        }
	    }
	    else {
	        renderText = displayRaw ? num.raw : num.formatted;
	    }
	    return renderText || "..";
	}
	exports.getRenderText = getRenderText;
	var DisplayNumberText = (function (_super) {
	    __extends(DisplayNumberText, _super);
	    function DisplayNumberText(props) {
	        return _super.call(this, props) || this;
	    }
	    DisplayNumberText.prototype.plainText = function () {
	        var _a = this.props, num = _a.num, maxWidth = _a.maxWidth, minPrecision = _a.minPrecision, maxPrecision = _a.maxPrecision, displayRaw = _a.displayRaw;
	        var font = this.props.font || defaultFont;
	        return getRenderText(num, maxWidth, minPrecision, maxPrecision, displayRaw, document, font);
	    };
	    DisplayNumberText.prototype.render = function () {
	        var renderText = this.plainText();
	        return React.createElement("span", null, renderText);
	    };
	    return DisplayNumberText;
	}(Sauce.Component));
	exports.DisplayNumberText = DisplayNumberText;
	var DisplayNumberSpan = (function (_super) {
	    __extends(DisplayNumberSpan, _super);
	    function DisplayNumberSpan(props) {
	        return _super.call(this, props) || this;
	    }
	    DisplayNumberSpan.prototype.render = function () {
	        var _a = this.props, num = _a.num, maxWidth = _a.maxWidth, minPrecision = _a.minPrecision, maxPrecision = _a.maxPrecision, displayRaw = _a.displayRaw, toggle = _a.toggle, id = _a.id;
	        var font = this.props.font || defaultFont;
	        var renderText = getRenderText(num, maxWidth, minPrecision, maxPrecision, displayRaw, document, font);
	        return React.createElement("span", { onClick: toggle, id: id, style: this.props.style, className: "tappable " + this.props.className }, renderText);
	    };
	    return DisplayNumberSpan;
	}(Sauce.Component));
	exports.DisplayNumberSpan = DisplayNumberSpan;
	var DisplayNumberSvgText = (function (_super) {
	    __extends(DisplayNumberSvgText, _super);
	    function DisplayNumberSvgText() {
	        return _super.apply(this, arguments) || this;
	    }
	    DisplayNumberSvgText.prototype.render = function () {
	        var _a = this.props, num = _a.num, maxWidth = _a.maxWidth, minPrecision = _a.minPrecision, maxPrecision = _a.maxPrecision, displayRaw = _a.displayRaw, toggle = _a.toggle, id = _a.id;
	        var font = this.props.font || defaultFont;
	        var renderText = getRenderText(num, maxWidth, minPrecision, maxPrecision, displayRaw, document, font);
	        return React.createElement("text", { onClick: toggle, id: id, style: this.props.style, className: "tappable " + this.props.className }, renderText);
	    };
	    return DisplayNumberSvgText;
	}(Sauce.Component));
	exports.DisplayNumberSvgText = DisplayNumberSvgText;
	var DisplayNumberPopoverContent = (function (_super) {
	    __extends(DisplayNumberPopoverContent, _super);
	    function DisplayNumberPopoverContent() {
	        return _super.apply(this, arguments) || this;
	    }
	    DisplayNumberPopoverContent.prototype.render = function () {
	        var _a = this.props, num = _a.num, maxWidth = _a.maxWidth, id = _a.id, open = _a.open, toggle = _a.toggle, displayRaw = _a.displayRaw, toggleRaw = _a.toggleRaw;
	        return React.createElement(reactstrap_1.Popover, { placement: "top", tether: { constraints: [{ to: 'scrollParent', pin: true }] }, target: id, isOpen: open, toggle: toggle },
	            React.createElement(reactstrap_1.PopoverContent, null,
	                React.createElement("table", { className: "parsed-number-popover-table" },
	                    React.createElement("tbody", null,
	                        React.createElement("tr", null,
	                            React.createElement("td", null, num.raw),
	                            React.createElement("td", null, "(raw)"),
	                            React.createElement("td", null,
	                                React.createElement("input", { onChange: toggleRaw, type: "radio", value: "raw", name: "rawgroup", defaultChecked: displayRaw }))),
	                        React.createElement("tr", null,
	                            React.createElement("td", null, num.value),
	                            React.createElement("td", null, "(parsed)"),
	                            React.createElement("td", null,
	                                React.createElement("input", { onChange: toggleRaw, type: "radio", value: "raw", name: "rawgroup", defaultChecked: !displayRaw })))))));
	    };
	    return DisplayNumberPopoverContent;
	}(Sauce.Component));
	exports.DisplayNumberPopoverContent = DisplayNumberPopoverContent;
	var DisplayNumberSpanWithPopover = (function (_super) {
	    __extends(DisplayNumberSpanWithPopover, _super);
	    function DisplayNumberSpanWithPopover(props) {
	        var _this = _super.call(this, props) || this;
	        _this.toggleTooltip = function () {
	            _this.setState({
	                open: !_this.state.open
	            });
	        };
	        _this.toggleRaw = function () {
	            _this.setState({
	                displayRaw: !_this.state.displayRaw
	            });
	        };
	        _this.state = { displayRaw: props.displayRaw, open: false };
	        return _this;
	    }
	    DisplayNumberSpanWithPopover.prototype.render = function () {
	        var _this = this;
	        var _a = this.props, num = _a.num, maxWidth = _a.maxWidth, minPrecision = _a.minPrecision, maxPrecision = _a.maxPrecision;
	        var _b = this.state, displayRaw = _b.displayRaw, open = _b.open;
	        var font = this.props.font || defaultFont;
	        var id = Util.makeDomId(_.uniqueId());
	        if (num == null)
	            return null;
	        return React.createElement("div", null,
	            React.createElement(DisplayNumberSpan, __assign({}, this.props, { displayRaw: this.state.displayRaw, id: id, toggle: function () { return _this.setState({ open: !_this.state.open }); } })),
	            React.createElement(DisplayNumberPopoverContent, __assign({}, this.props, { id: id, toggle: function () { return _this.setState({ open: !_this.state.open }); }, toggleRaw: function () { return _this.setState({ displayRaw: !_this.state.displayRaw }); }, open: open })));
	    };
	    return DisplayNumberSpanWithPopover;
	}(Sauce.Component));
	exports.DisplayNumberSpanWithPopover = DisplayNumberSpanWithPopover;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(50);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./DisplayNumber.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./DisplayNumber.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, ".parsed-number-popover-table tr{min-width:120px;display:flex;justify-content:space-between}", ""]);
	
	// exports


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(52);


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(53);
	var ReactServerRendering = __webpack_require__(54);
	var ReactVersion = __webpack_require__(68);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(34);

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(55);
	
	var React = __webpack_require__(56);
	var ReactDOMContainerInfo = __webpack_require__(57);
	var ReactDefaultBatchingStrategy = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(59);
	var ReactMarkupChecksum = __webpack_require__(60);
	var ReactReconciler = __webpack_require__(61);
	var ReactServerBatchingStrategy = __webpack_require__(62);
	var ReactServerRenderingTransaction = __webpack_require__(63);
	var ReactUpdates = __webpack_require__(64);
	
	var emptyObject = __webpack_require__(65);
	var instantiateReactComponent = __webpack_require__(66);
	var invariant = __webpack_require__(67);
	
	var pendingTransactions = 0;
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToStringImpl(element, makeStaticMarkup) {
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);
	
	    pendingTransactions++;
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, true);
	      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
	      );
	      if (false) {
	        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
	      }
	      if (!makeStaticMarkup) {
	        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
	      }
	      return markup;
	    }, null);
	  } finally {
	    pendingTransactions--;
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    if (!pendingTransactions) {
	      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	    }
	  }
	}
	
	/**
	 * Render a ReactElement to its initial HTML. This should only be used on the
	 * server.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
	 */
	function renderToString(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
	  return renderToStringImpl(element, false);
	}
	
	/**
	 * Similar to renderToString, except this doesn't create extra DOM attributes
	 * such as data-react-id that React uses internally.
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
	 */
	function renderToStaticMarkup(element) {
	  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
	  return renderToStringImpl(element, true);
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(31);

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(2);

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(159);

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(132);

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(59);

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(161);

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(56);

/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(125);

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(53);

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(19);

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(111);

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(7);

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(163);

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./MatrixViewer.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./MatrixViewer.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, ".background{fill:#fafad2;z-index:-5}line{stroke:#fff;z-index:50}line.label-underline{stroke:#000}", ""]);
	
	// exports


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __assign = (this && this.__assign) || Object.assign || function(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	            t[p] = s[p];
	    }
	    return t;
	};
	var React = __webpack_require__(2);
	var Sauce = __webpack_require__(7);
	var _ = __webpack_require__(11);
	var Form_1 = __webpack_require__(10);
	var d3 = __webpack_require__(16);
	var Basic_1 = __webpack_require__(29);
	var DisplayNumber_1 = __webpack_require__(48);
	__webpack_require__(72);
	var NumericMatrix = (function (_super) {
	    __extends(NumericMatrix, _super);
	    function NumericMatrix(props) {
	        return _super.call(this, props) || this;
	    }
	    NumericMatrix.prototype.render = function () {
	        var _a = this.props, leftRowLabels = _a.leftRowLabels, rightRowLabels = _a.rightRowLabels, columnLabels = _a.columnLabels, flush = _a.flush, matrix = _a.matrix;
	        var _b = this.props, outerWidth = _b.outerWidth, outerHeight = _b.outerHeight;
	        var margin = __assign({ top: 0, left: 0, right: 0, bottom: 0 }, this.props.margin);
	        var rowLen = matrix.rows;
	        var colLen = matrix.cols;
	        if (!_.isFinite(outerWidth)) {
	            outerWidth = colLen * 50 + margin.left + margin.right;
	            if (leftRowLabels)
	                outerWidth += 50;
	            if (rightRowLabels)
	                outerWidth += 50;
	        }
	        if (!_.isFinite(outerHeight)) {
	            outerHeight = rowLen * 50 + margin.top + margin.bottom;
	            if (columnLabels)
	                outerHeight += 50;
	        }
	        var width = outerWidth - margin.left - margin.right;
	        var height = outerHeight - margin.top - margin.bottom;
	        var colLabelSize = columnLabels && columnLabels.length > 0 ? 1 : 0;
	        var rowLabelSize = leftRowLabels && leftRowLabels.length > 0 ? 1 : 0;
	        var rightRowLabelSize = rightRowLabels && rightRowLabels.length > 0 ? 1 : 0;
	        var x = d3.scaleBand()
	            .rangeRound([0, width])
	            .domain(d3.range(colLen + rowLabelSize + rightRowLabelSize));
	        var y = d3.scaleBand()
	            .rangeRound([0, height])
	            .domain(d3.range(rowLen + colLabelSize))
	            .align(0);
	        var entryEls = [];
	        var _loop_1 = function (i) {
	            var _loop_2 = function (j) {
	                var entry = matrix.getEntry(i, j);
	                entryEls.push(React.createElement("div", { key: i + "-" + j, className: "matrix-entry-container", style: {
	                        top: y(i + colLabelSize),
	                        left: x(j + rowLabelSize),
	                        backgroundColor: (i + j) % 2 ? "white" : "lightgrey",
	                        width: x.bandwidth(),
	                        height: y.bandwidth(),
	                        border: entry && entry.valid ? "1px solid black" : "1px solid red",
	                        borderBottom: i === rowLen - 1 ? "1px solid black" : "none",
	                        borderRight: j === colLen - 1 ? "1px solid black" : "none",
	                    } }, flush ?
	                    React.createElement(Form_1.NumberInput, { value: entry, className: "matrix-entry-input", flush: function (val) { return flush(i, j, val); }, processor: Basic_1.AnyRealExpression })
	                    :
	                        React.createElement(DisplayNumber_1.DisplayNumberSpanWithPopover, { num: entry, className: "matrix-entry-number", displayRaw: true, maxPrecision: 7, minPrecision: 3, maxWidth: x.bandwidth() })));
	            };
	            for (var j = 0; j < colLen; j++) {
	                _loop_2(j);
	            }
	        };
	        for (var i = 0; i < rowLen; i++) {
	            _loop_1(i);
	        }
	        var colLabelEls = [];
	        if (columnLabels) {
	            for (var j = 0; j < columnLabels.length; j++) {
	                var i = 0;
	                colLabelEls.push(React.createElement("div", { className: "matrix-entry-container", key: i + "-" + j, style: {
	                        top: y(0),
	                        left: x(j + rowLabelSize),
	                        backgroundColor: (j) % 2 ? "white" : "lightgrey",
	                        width: x.bandwidth(),
	                        height: y.bandwidth()
	                    } }, columnLabels[j]));
	            }
	        }
	        var rowLabelEls = [];
	        if (leftRowLabels) {
	            for (var i = 0; i < leftRowLabels.length; i++) {
	                var j = 0;
	                rowLabelEls.push(React.createElement("div", { className: "matrix-entry-container", key: i + "-" + j, style: {
	                        top: y(i + colLabelSize),
	                        left: x(0),
	                        backgroundColor: (i) % 2 ? "white" : "lightgrey",
	                        width: x.bandwidth(),
	                        height: y.bandwidth()
	                    } }, leftRowLabels[i]));
	            }
	        }
	        if (rightRowLabels) {
	            for (var i = 0; i < rightRowLabels.length; i++) {
	                var j = colLen + rowLabelSize;
	                rowLabelEls.push(React.createElement("div", { className: "matrix-entry-container", key: i + "-" + j, style: {
	                        top: y(i + colLabelSize),
	                        left: x(j),
	                        backgroundColor: (i) % 2 ? "white" : "lightgrey",
	                        width: x.bandwidth(),
	                        height: y.bandwidth()
	                    } },
	                    React.createElement("span", { className: 'right-row-label' }, rightRowLabels[i])));
	            }
	        }
	        return React.createElement("div", { className: "matrix-container", style: { width: outerWidth, height: outerHeight } },
	            rowLabelEls,
	            colLabelEls,
	            entryEls);
	    };
	    return NumericMatrix;
	}(Sauce.Component));
	exports.NumericMatrix = NumericMatrix;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(73);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./Matrix.scss", function() {
				var newContent = require("!!./../../../../node_modules/css-loader/index.js!./../../../../node_modules/sass-loader/index.js!./Matrix.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, ".matrix-container{position:relative}.matrix-container .matrix-entry-container{position:absolute;display:flex;align-items:center;justify-content:center}.matrix-container .matrix-entry-container .right-row-label{transform:rotate(-45deg)}.matrix-container .matrix-entry-container .matrix-entry-input{width:100%;background-color:transparent;text-align:center;border:none}.matrix-container .matrix-entry-container .matrix-entry-input.invalid{border:1px solid red}", ""]);
	
	// exports


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Sauce = __webpack_require__(7);
	var React = __webpack_require__(2);
	var react_router_1 = __webpack_require__(5);
	var Nav = (function (_super) {
	    __extends(Nav, _super);
	    function Nav() {
	        return _super.apply(this, arguments) || this;
	    }
	    Nav.prototype.render = function () {
	        return React.createElement("div", { className: "container" },
	            React.createElement("ul", null,
	                React.createElement(react_router_1.Link, { to: "/" },
	                    React.createElement("li", null, "Home")),
	                React.createElement(react_router_1.Link, { to: "/markov", activeStyle: { fontWeight: "bold" } },
	                    React.createElement("li", null, "Markov")),
	                React.createElement(react_router_1.Link, { to: "/parametric", activeStyle: { fontWeight: "bold" } },
	                    React.createElement("li", null, "Parametric")),
	                React.createElement(react_router_1.Link, { to: "/matrixtest", activeStyle: { fontWeight: "bold" } },
	                    React.createElement("li", null, "Matrix"))),
	            this.props.children);
	    };
	    return Nav;
	}(Sauce.Component));
	exports.Nav = Nav;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(76);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(24)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./global.scss", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/sass-loader/index.js!./global.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(23)();
	// imports
	
	
	// module
	exports.push([module.id, ".katex-mathml{display:none}*{font-family:Anonymous Pro}.tappable{cursor:pointer}input.invalid,textarea.invalid{border:1px solid red;background-color:#f6b5b9}", ""]);
	
	// exports


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["React"] = __webpack_require__(2);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(17);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Tether"] = __webpack_require__(80);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(965);

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(3))(698);

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// assets/scripts/app.js